import * as React from "react"

const SvgComponent = (props) => (
    <svg
        width={1170}
        height={166}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 1170 166`}

    >
        <path
            d="m4.638 86.07 62.985-36.32a13.606 13.606 0 0 1 12.304 0l62.979 36.32c3.396 1.958 3.396 5.134 0 7.092L79.925 129.48a13.612 13.612 0 0 1-12.304 0L4.638 93.162c-3.397-1.959-3.397-5.134 0-7.092Z"
            fill="#282739"
        />
        <path
            d="M128.333 75.932H94.35L73.7 103.015h54.634l23.622-13.541-23.623-13.542ZM70.915 67.469H50.782l-6.4 3.667-.518-.547-2.281 1.312 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.421-7.706-4.421Z"
            fill="#101015"
        />
        <path
            d="M59.477 74.026H39.344l-6.4 3.667-.518-.547-2.28 1.312 2.267 1.3h1.5l5.426 3.11h20.133l7.711-4.421-7.707-4.421Z"
            fill="#101015"
        />
        <path
            d="M48.002 80.577H27.869l-6.4 3.667-.518-.547-2.281 1.31 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.42-7.706-4.42Z"
            fill="#101015"
        />
        <path
            d="M61.173 88.28H41.04l-6.4 3.668-.518-.547-2.281 1.31 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.42-7.706-4.42Z"
            fill="#101015"
        />
        <path
            d="M3.956 87.82c-.45.45-.964 1.172-.848 2.048.115.877.836 1.74 2.03 2.428l62.984 36.32c1.493.861 3.5 1.335 5.65 1.335 2.15 0 4.157-.474 5.65-1.335l62.985-36.32a5.678 5.678 0 0 0 1.182-.884c.451-.451.964-1.173.848-2.048-.115-.878-.836-1.74-2.03-2.428l-62.985-36.32c-1.493-.861-3.5-1.335-5.65-1.335-2.15 0-4.157.474-5.65 1.335L5.138 86.936a5.68 5.68 0 0 0-1.182.884Zm-.707-.707a6.655 6.655 0 0 1 1.39-1.043l62.984-36.32c3.396-1.96 8.903-1.96 12.3 0l62.984 36.32c3.396 1.958 3.396 5.133 0 7.092l-62.985 36.32c-3.396 1.959-8.903 1.959-12.3 0L4.639 93.162c-2.843-1.64-3.306-4.132-1.389-6.05Z"
            fill="#DEDDE2"
        />
        <path
            d="M93.843 54.36H73.709l-6.4 3.667-.518-.547-2.281 1.312 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.421-7.705-4.421Z"
            fill="#93A865"
        />
        <path d="M69.027 58.79v-3.933l-2.268 1.3v3.934l2.268-1.3Z" fill="#A67C52" />
        <path d="M64.491 58.79v-3.933l2.268 1.3v3.934l-2.268-1.3Z" fill="#C69C6D" />
        <path
            d="m66.76 53.556-2.269 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M74.47 51.992V46.38L66.76 50.8v5.612l7.712-4.42Z" fill="#75934C" />
        <path
            d="M59.047 51.992V46.38l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m66.759 41.964-7.712 4.421 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M74.47 44.654V39.04l-7.711 4.422v5.611l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M59.047 44.654V39.04l7.712 4.422v5.611l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m66.759 34.62-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M74.47 37.312V31.7l-7.711 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M59.047 37.312V31.7l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="M66.759 27.279 59.047 31.7l7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M46.125 71.898v-3.936l-2.268 1.3v3.934l2.268-1.298Z"
            fill="#A67C52"
        />
        <path
            d="M41.588 71.898v-3.936l2.268 1.3v3.934l-2.268-1.298Z"
            fill="#C69C6D"
        />
        <path
            d="m43.857 66.665-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M51.568 65.106v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M36.144 65.106v-5.611l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m43.856 55.073-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M51.568 57.761v-5.61l-7.712 4.42v5.612l7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M36.144 57.761v-5.61l7.712 4.42v5.612l-7.712-4.422Z"
            fill="#AAD86F"
        />
        <path
            d="m43.856 47.73-7.712 4.42 7.712 4.422 7.712-4.422-7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M51.568 50.42V44.81l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M36.144 50.42V44.81l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m43.856 40.388-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path d="M34.649 78.45v-3.934l-2.268 1.3v3.934l2.268-1.3Z" fill="#A67C52" />
        <path d="M30.112 78.45v-3.934l2.268 1.3v3.934l-2.268-1.3Z" fill="#C69C6D" />
        <path
            d="m32.383 73.216-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M40.093 71.657v-5.613l-7.712 4.421v5.61l7.712-4.418Z"
            fill="#75934C"
        />
        <path
            d="M24.668 71.657v-5.613l7.712 4.421v5.61l-7.712-4.418Z"
            fill="#AAD86F"
        />
        <path
            d="m32.38 61.624-7.712 4.421 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M40.093 64.313v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M24.668 64.313v-5.611l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m32.38 54.28-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path d="M40.093 56.97V51.36L32.38 55.78v5.61l7.712-4.42Z" fill="#75934C" />
        <path
            d="M24.668 56.97V51.36l7.712 4.421v5.61l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m32.38 46.939-7.712 4.421 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#C7F08F"
        />
        <path d="M23.21 85.01v-3.934l-2.269 1.3v3.934l2.268-1.3Z" fill="#A67C52" />
        <path d="M18.673 85.01v-3.934l2.268 1.3v3.934l-2.268-1.3Z" fill="#C69C6D" />
        <path
            d="m20.942 79.775-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M28.653 78.22V72.61l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M13.229 78.22V72.61l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m20.942 68.183-7.713 4.421 7.713 4.42 7.712-4.42-7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M28.653 70.872v-5.61l-7.712 4.42v5.611l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M13.229 70.872v-5.61l7.712 4.42v5.611l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m20.942 60.837-7.713 4.421 7.713 4.421 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M28.653 63.53V57.92l-7.712 4.42v5.613l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M13.229 63.53V57.92l7.712 4.42v5.613l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m20.942 53.498-7.713 4.42 7.713 4.422 7.712-4.421-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M36.381 92.711v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M31.845 92.711v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m34.113 87.478-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M41.825 85.919v-5.612l-7.712 4.42v5.613l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M26.4 85.919v-5.612l7.712 4.42v5.613L26.4 85.919Z"
            fill="#AAD86F"
        />
        <path
            d="m34.115 75.886-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M41.825 78.575v-5.608l-7.712 4.421V83l7.712-4.424Z"
            fill="#75934C"
        />
        <path d="M26.4 78.575v-5.608l7.712 4.421V83L26.4 78.575Z" fill="#AAD86F" />
        <path
            d="m34.115 68.543-7.712 4.42 7.712 4.422 7.712-4.422-7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M41.825 71.234v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M26.4 71.234v-5.611l7.712 4.42v5.612L26.4 71.234Z"
            fill="#AAD86F"
        />
        <path
            d="m34.115 61.2-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M92.284 70.596v-3.928l-2.265 1.3v3.927l2.264-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M87.755 70.596v-3.928l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m90.019 65.37-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M97.72 63.813v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M82.32 63.813v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m90.02 53.797-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M97.72 56.482v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M82.32 56.482v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m90.02 46.466-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M97.72 49.152v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M82.32 49.152v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m90.02 39.136-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M105.434 78.286v-3.928l-2.265 1.3v3.927l2.265-1.299Z"
            fill="#A67C52"
        />
        <path
            d="M100.905 78.286v-3.928l2.265 1.3v3.927l-2.265-1.299Z"
            fill="#C69C6D"
        />
        <path
            d="m103.168 73.06-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M110.87 71.504v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M95.47 71.504v-5.6l7.701 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m103.17 61.487-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M110.87 64.172v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M95.47 64.172v-5.6l7.701 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m103.17 54.156-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M110.87 56.837v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M95.47 56.837v-5.6l7.701 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m103.17 46.826-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M117.344 84.066v-3.927l-2.265 1.3v3.927l2.265-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M112.815 84.066v-3.927l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m115.079 78.84-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M122.78 77.283v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M107.381 77.283v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m115.081 67.267-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M122.78 69.952v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M107.381 69.952v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m115.081 59.936-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M122.78 62.622v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M107.381 62.622v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m115.081 52.606-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M130.495 91.755v-3.927l-2.266 1.3v3.927l2.266-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M125.966 91.755v-3.927l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m128.232 86.53-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M135.93 84.973v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M120.531 84.973v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m128.231 74.957-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M135.93 77.64v-5.599l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M120.531 77.64v-5.599l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m128.231 67.626-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M135.93 70.312v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M120.531 70.312v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m128.231 60.296-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M50.077 89.504V62.126L73.7 75.668v27.378L50.077 89.504Z"
            fill="#DEDDE2"
        />
        <path
            d="M97.32 89.504V62.126L73.698 75.668v27.378L97.32 89.504Z"
            fill="#ADABB9"
        />
        <path
            d="M73.698 48.584 50.076 62.126l23.622 13.541L97.32 62.126 73.698 48.584Z"
            fill="#E3DAD7"
        />
        <path
            d="M50.077 62.216V34.838L73.7 48.378v27.379L50.077 62.216Z"
            fill="#DEDDE2"
        />
        <path
            d="M97.32 62.216V34.838l-23.622 13.54v27.379L97.32 62.216Z"
            fill="#ADABB9"
        />
        <path
            d="m73.698 21.297-23.622 13.54L73.698 48.38 97.32 34.838 73.698 21.297Z"
            fill="#D7D6DD"
        />
        <path
            d="M83.306 54.21v-4.72l5.741-3.315v4.721l4.526-2.614v5.655l-4.526 2.614v4.765l-5.74 3.315v-4.765l-4.528 2.614v-5.654l4.527-2.615ZM64.493 54.21v-4.72l-5.741-3.315v4.721l-4.526-2.614v5.655l4.526 2.614v4.765l5.74 3.315v-4.765l4.527 2.614v-5.654l-4.526-2.615Z"
            fill="#4361EE"
        />
        <path
            d="m70.311 74.217-16.905-9.621.007 22.367 16.9 9.617-.002-22.363Z"
            fill="#ADABB9"
        />
        <path
            d="m54.18 86.544 16.13 9.176v-21.5l-16.135-9.18.006 21.504Z"
            fill="#FAF8F8"
        />
        <path
            d="m77.268 74.217 16.905-9.621-.007 22.367-16.9 9.617.002-22.363Z"
            fill="#888595"
        />
        <path
            d="m93.397 86.544-16.13 9.176v-21.5l16.137-9.18-.007 21.504Z"
            fill="#E9E5F2"
        />
        <path
            d="m73.698 21.297-23.62 13.54 23.62 13.542L97.32 34.838 73.698 21.297ZM55.25 34.837l18.448-10.575 18.448 10.576-18.448 10.575L55.25 34.838Z"
            fill="#F4EFED"
        />
        <path
            d="m171.638 86.07 62.985-36.32a13.607 13.607 0 0 1 12.304 0l62.979 36.32c3.396 1.958 3.396 5.134 0 7.092l-62.981 36.318a13.613 13.613 0 0 1-12.304 0l-62.983-36.318c-3.397-1.959-3.397-5.134 0-7.092Z"
            fill="#282739"
        />
        <path
            d="M295.333 75.932H261.35l-20.651 27.083h54.635l23.622-13.541-23.623-13.542ZM237.915 67.469h-20.133l-6.4 3.667-.518-.547-2.281 1.312 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.421-7.706-4.421Z"
            fill="#101015"
        />
        <path
            d="M226.477 74.026h-20.133l-6.4 3.667-.518-.547-2.28 1.312 2.267 1.3h1.5l5.426 3.11h20.132l7.712-4.421-7.706-4.421Z"
            fill="#101015"
        />
        <path
            d="M215.002 80.577h-20.133l-6.4 3.667-.518-.547-2.281 1.31 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.42-7.706-4.42Z"
            fill="#101015"
        />
        <path
            d="M228.173 88.28H208.04l-6.4 3.668-.518-.547-2.281 1.31 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.42-7.706-4.42Z"
            fill="#101015"
        />
        <path
            d="M170.956 87.82c-.451.45-.964 1.172-.848 2.048.115.877.836 1.74 2.03 2.428l62.984 36.32c1.494.861 3.5 1.335 5.65 1.335 2.151 0 4.157-.474 5.651-1.335l62.984-36.32a5.678 5.678 0 0 0 1.182-.884c.451-.451.964-1.173.848-2.048-.115-.878-.836-1.74-2.03-2.428l-62.984-36.32c-1.494-.861-3.5-1.335-5.651-1.335-2.15 0-4.156.474-5.65 1.335l-62.984 36.32a5.682 5.682 0 0 0-1.182.884Zm-.707-.707a6.658 6.658 0 0 1 1.389-1.043l62.985-36.32c3.396-1.96 8.903-1.96 12.299 0l62.985 36.32c3.396 1.958 3.396 5.133 0 7.092l-62.985 36.32c-3.396 1.959-8.903 1.959-12.299 0l-62.985-36.32c-2.843-1.64-3.306-4.132-1.389-6.05Z"
            fill="#DEDDE2"
        />
        <path
            d="M260.843 54.36h-20.134l-6.4 3.667-.518-.547-2.281 1.312 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.421-7.705-4.421Z"
            fill="#93A865"
        />
        <path
            d="M236.027 58.79v-3.933l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M231.491 58.79v-3.933l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m233.759 53.556-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M241.471 51.992V46.38l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M226.047 51.992V46.38l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m233.759 41.964-7.712 4.421 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M241.471 44.654V39.04l-7.712 4.422v5.611l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M226.047 44.654V39.04l7.712 4.422v5.611l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m233.759 34.62-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M241.471 37.312V31.7l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M226.047 37.312V31.7l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m233.759 27.279-7.712 4.421 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M213.125 71.898v-3.936l-2.268 1.3v3.934l2.268-1.298Z"
            fill="#A67C52"
        />
        <path
            d="M208.588 71.898v-3.936l2.268 1.3v3.934l-2.268-1.298Z"
            fill="#C69C6D"
        />
        <path
            d="m210.857 66.665-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M218.568 65.106v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M203.144 65.106v-5.611l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m210.857 55.073-7.712 4.42 7.712 4.422 7.711-4.421-7.711-4.421Z"
            fill="#75934C"
        />
        <path
            d="M218.568 57.761v-5.61l-7.712 4.42v5.612l7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M203.144 57.761v-5.61l7.712 4.42v5.612l-7.712-4.422Z"
            fill="#AAD86F"
        />
        <path
            d="m210.857 47.73-7.712 4.42 7.712 4.422 7.711-4.422-7.711-4.42Z"
            fill="#75934C"
        />
        <path
            d="M218.568 50.42V44.81l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M203.144 50.42V44.81l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m210.857 40.388-7.712 4.42 7.712 4.422 7.711-4.421-7.711-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M201.649 78.45v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M197.112 78.45v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m199.383 73.216-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M207.093 71.657v-5.613l-7.712 4.421v5.61l7.712-4.418Z"
            fill="#75934C"
        />
        <path
            d="M191.668 71.657v-5.613l7.712 4.421v5.61l-7.712-4.418Z"
            fill="#AAD86F"
        />
        <path
            d="m199.38 61.624-7.712 4.421 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M207.093 64.313v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M191.668 64.313v-5.611l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m199.38 54.28-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M207.093 56.97V51.36l-7.712 4.421v5.61l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M191.668 56.97V51.36l7.712 4.421v5.61l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m199.38 46.939-7.712 4.421 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#C7F08F"
        />
        <path
            d="M190.209 85.01v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M185.673 85.01v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m187.942 79.775-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M195.653 78.22V72.61l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M180.229 78.22V72.61l7.711 4.42v5.612l-7.711-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m187.942 68.183-7.713 4.421 7.713 4.42 7.712-4.42-7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M195.653 70.872v-5.61l-7.712 4.42v5.611l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M180.229 70.872v-5.61l7.711 4.42v5.611l-7.711-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m187.942 60.837-7.713 4.421 7.713 4.421 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M195.653 63.53V57.92l-7.712 4.42v5.613l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M180.229 63.53V57.92l7.711 4.42v5.613l-7.711-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m187.942 53.498-7.713 4.42 7.713 4.422 7.712-4.421-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M203.381 92.711v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M198.845 92.711v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m201.113 87.478-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M208.825 85.919v-5.612l-7.712 4.42v5.613l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M193.4 85.919v-5.612l7.712 4.42v5.613l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m201.115 75.886-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M208.825 78.575v-5.608l-7.712 4.421V83l7.712-4.424Z"
            fill="#75934C"
        />
        <path
            d="M193.4 78.575v-5.608l7.712 4.421V83l-7.712-4.424Z"
            fill="#AAD86F"
        />
        <path
            d="m201.115 68.543-7.712 4.42 7.712 4.422 7.712-4.422-7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M208.825 71.234v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M193.4 71.234v-5.611l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m201.115 61.2-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M259.284 70.596v-3.928l-2.265 1.3v3.927l2.265-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M254.755 70.596v-3.928l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m257.019 65.37-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M264.719 63.813v-5.6l-7.699 4.414v5.6l7.699-4.414Z"
            fill="#75934C"
        />
        <path d="M249.32 63.813v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m257.019 53.797-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path
            d="M264.719 56.482v-5.6l-7.699 4.414v5.6l7.699-4.414Z"
            fill="#75934C"
        />
        <path d="M249.32 56.482v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m257.019 46.466-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path
            d="M264.719 49.152v-5.6l-7.699 4.414v5.6l7.699-4.414Z"
            fill="#75934C"
        />
        <path d="M249.32 49.152v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m257.019 39.136-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M272.434 78.286v-3.928l-2.265 1.3v3.927l2.265-1.299Z"
            fill="#A67C52"
        />
        <path
            d="M267.905 78.286v-3.928l2.265 1.3v3.927l-2.265-1.299Z"
            fill="#C69C6D"
        />
        <path
            d="m270.168 73.06-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M277.87 71.504v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M262.471 71.504v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m270.17 61.487-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M277.87 64.172v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M262.471 64.172v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m270.17 54.156-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M277.87 56.837v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M262.471 56.837v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m270.17 46.826-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M284.344 84.066v-3.927l-2.265 1.3v3.927l2.265-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M279.815 84.066v-3.927l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m282.079 78.84-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M289.78 77.283v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M274.381 77.283v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m282.081 67.267-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M289.78 69.952v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M274.381 69.952v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m282.081 59.936-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M289.78 62.622v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M274.381 62.622v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m282.081 52.606-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M297.495 91.755v-3.927l-2.266 1.3v3.927l2.266-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M292.966 91.755v-3.927l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m295.232 86.53-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M302.93 84.973v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M287.531 84.973v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m295.231 74.957-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M302.93 77.64v-5.599l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M287.531 77.64v-5.599l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m295.231 67.626-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M302.93 70.312v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M287.531 70.312v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m295.231 60.296-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M217.077 89.504V62.126l23.622 13.542v27.378l-23.622-13.542Z"
            fill="#DEDDE2"
        />
        <path
            d="M264.32 89.504V62.126l-23.622 13.542v27.378l23.622-13.542Z"
            fill="#ADABB9"
        />
        <path
            d="m240.698 48.584-23.622 13.542 23.622 13.541 23.622-13.541-23.622-13.542Z"
            fill="#E3DAD7"
        />
        <path
            d="M217.077 62.216V34.838l23.622 13.54v27.379l-23.622-13.541Z"
            fill="#DEDDE2"
        />
        <path
            d="M264.32 62.216V34.838l-23.622 13.54v27.379l23.622-13.541Z"
            fill="#ADABB9"
        />
        <path
            d="m240.698 21.297-23.622 13.54 23.622 13.543 23.622-13.542-23.622-13.541Z"
            fill="#D7D6DD"
        />
        <path
            d="M250.306 54.21v-4.72l5.741-3.315v4.721l4.526-2.614v5.655l-4.526 2.614v4.765l-5.741 3.315v-4.765l-4.527 2.614v-5.654l4.527-2.615ZM231.493 54.21v-4.72l-5.741-3.315v4.721l-4.526-2.614v5.655l4.526 2.614v4.765l5.741 3.315v-4.765l4.527 2.614v-5.654l-4.527-2.615Z"
            fill="#4361EE"
        />
        <path
            d="m237.311 74.217-16.905-9.621.007 22.367 16.9 9.617-.002-22.363Z"
            fill="#ADABB9"
        />
        <path
            d="m221.181 86.544 16.13 9.176v-21.5l-16.136-9.18.006 21.504Z"
            fill="#FAF8F8"
        />
        <path
            d="m244.268 74.217 16.905-9.621-.007 22.367-16.9 9.617.002-22.363Z"
            fill="#888595"
        />
        <path
            d="m260.398 86.544-16.13 9.176v-21.5l16.136-9.18-.006 21.504Z"
            fill="#E9E5F2"
        />
        <path
            d="m240.698 21.297-23.621 13.54 23.621 13.542 23.622-13.541-23.622-13.541Zm-18.448 13.54 18.448-10.575 18.448 10.576-18.448 10.575-18.448-10.575Z"
            fill="#F4EFED"
        />
        <path
            d="m338.638 86.07 62.985-36.32a13.607 13.607 0 0 1 12.304 0l62.979 36.32c3.396 1.958 3.396 5.134 0 7.092l-62.981 36.318a13.613 13.613 0 0 1-12.304 0l-62.983-36.318c-3.397-1.959-3.397-5.134 0-7.092Z"
            fill="#282739"
        />
        <path
            d="M462.333 75.932H428.35l-20.651 27.083h54.635l23.622-13.541-23.623-13.542ZM404.915 67.469h-20.133l-6.4 3.667-.518-.547-2.281 1.312 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.421-7.706-4.421Z"
            fill="#101015"
        />
        <path
            d="M393.477 74.026h-20.133l-6.4 3.667-.518-.547-2.28 1.312 2.267 1.3h1.5l5.426 3.11h20.132l7.712-4.421-7.706-4.421Z"
            fill="#101015"
        />
        <path
            d="M382.002 80.577h-20.133l-6.4 3.667-.518-.547-2.281 1.31 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.42-7.706-4.42Z"
            fill="#101015"
        />
        <path
            d="M395.173 88.28H375.04l-6.4 3.668-.518-.547-2.281 1.31 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.42-7.706-4.42Z"
            fill="#101015"
        />
        <path
            d="M337.956 87.82c-.451.45-.964 1.172-.848 2.048.115.877.836 1.74 2.03 2.428l62.984 36.32c1.494.861 3.5 1.335 5.65 1.335 2.151 0 4.157-.474 5.651-1.335l62.984-36.32a5.678 5.678 0 0 0 1.182-.884c.451-.451.964-1.173.848-2.048-.115-.878-.836-1.74-2.03-2.428l-62.984-36.32c-1.494-.861-3.5-1.335-5.651-1.335-2.15 0-4.156.474-5.65 1.335l-62.984 36.32a5.682 5.682 0 0 0-1.182.884Zm-.707-.707a6.658 6.658 0 0 1 1.389-1.043l62.985-36.32c3.396-1.96 8.903-1.96 12.299 0l62.985 36.32c3.396 1.958 3.396 5.133 0 7.092l-62.985 36.32c-3.396 1.959-8.903 1.959-12.299 0l-62.985-36.32c-2.843-1.64-3.306-4.132-1.389-6.05Z"
            fill="#DEDDE2"
        />
        <path
            d="M427.843 54.36h-20.134l-6.4 3.667-.518-.547-2.281 1.312 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.421-7.705-4.421Z"
            fill="#93A865"
        />
        <path
            d="M403.027 58.79v-3.933l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M398.491 58.79v-3.933l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m400.759 53.556-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M408.471 51.992V46.38l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M393.047 51.992V46.38l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m400.759 41.964-7.712 4.421 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M408.471 44.654V39.04l-7.712 4.422v5.611l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M393.047 44.654V39.04l7.712 4.422v5.611l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m400.759 34.62-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M408.471 37.312V31.7l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M393.047 37.312V31.7l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m400.759 27.279-7.712 4.421 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M380.125 71.898v-3.936l-2.268 1.3v3.934l2.268-1.298Z"
            fill="#A67C52"
        />
        <path
            d="M375.588 71.898v-3.936l2.268 1.3v3.934l-2.268-1.298Z"
            fill="#C69C6D"
        />
        <path
            d="m377.857 66.665-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M385.568 65.106v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M370.144 65.106v-5.611l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m377.857 55.073-7.712 4.42 7.712 4.422 7.711-4.421-7.711-4.421Z"
            fill="#75934C"
        />
        <path
            d="M385.568 57.761v-5.61l-7.712 4.42v5.612l7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M370.144 57.761v-5.61l7.712 4.42v5.612l-7.712-4.422Z"
            fill="#AAD86F"
        />
        <path
            d="m377.857 47.73-7.712 4.42 7.712 4.422 7.711-4.422-7.711-4.42Z"
            fill="#75934C"
        />
        <path
            d="M385.568 50.42V44.81l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M370.144 50.42V44.81l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m377.857 40.388-7.712 4.42 7.712 4.422 7.711-4.421-7.711-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M368.649 78.45v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M364.112 78.45v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m366.383 73.216-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M374.093 71.657v-5.613l-7.712 4.421v5.61l7.712-4.418Z"
            fill="#75934C"
        />
        <path
            d="M358.668 71.657v-5.613l7.712 4.421v5.61l-7.712-4.418Z"
            fill="#AAD86F"
        />
        <path
            d="m366.38 61.624-7.712 4.421 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M374.093 64.313v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M358.668 64.313v-5.611l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m366.38 54.28-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M374.093 56.97V51.36l-7.712 4.421v5.61l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M358.668 56.97V51.36l7.712 4.421v5.61l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m366.38 46.939-7.712 4.421 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#C7F08F"
        />
        <path
            d="M357.209 85.01v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M352.673 85.01v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m354.942 79.775-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M362.653 78.22V72.61l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M347.229 78.22V72.61l7.711 4.42v5.612l-7.711-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m354.942 68.183-7.713 4.421 7.713 4.42 7.712-4.42-7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M362.653 70.872v-5.61l-7.712 4.42v5.611l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M347.229 70.872v-5.61l7.711 4.42v5.611l-7.711-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m354.942 60.837-7.713 4.421 7.713 4.421 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M362.653 63.53V57.92l-7.712 4.42v5.613l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M347.229 63.53V57.92l7.711 4.42v5.613l-7.711-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m354.942 53.498-7.713 4.42 7.713 4.422 7.712-4.421-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M370.381 92.711v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M365.845 92.711v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m368.113 87.478-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M375.825 85.919v-5.612l-7.712 4.42v5.613l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M360.4 85.919v-5.612l7.712 4.42v5.613l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m368.115 75.886-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M375.825 78.575v-5.608l-7.712 4.421V83l7.712-4.424Z"
            fill="#75934C"
        />
        <path
            d="M360.4 78.575v-5.608l7.712 4.421V83l-7.712-4.424Z"
            fill="#AAD86F"
        />
        <path
            d="m368.115 68.543-7.712 4.42 7.712 4.422 7.712-4.422-7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M375.825 71.234v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M360.4 71.234v-5.611l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m368.115 61.2-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M426.284 70.596v-3.928l-2.265 1.3v3.927l2.265-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M421.755 70.596v-3.928l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m424.019 65.37-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M431.719 63.813v-5.6l-7.699 4.414v5.6l7.699-4.414Z"
            fill="#75934C"
        />
        <path d="M416.32 63.813v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m424.019 53.797-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path
            d="M431.719 56.482v-5.6l-7.699 4.414v5.6l7.699-4.414Z"
            fill="#75934C"
        />
        <path d="M416.32 56.482v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m424.019 46.466-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path
            d="M431.719 49.152v-5.6l-7.699 4.414v5.6l7.699-4.414Z"
            fill="#75934C"
        />
        <path d="M416.32 49.152v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m424.019 39.136-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M439.434 78.286v-3.928l-2.265 1.3v3.927l2.265-1.299Z"
            fill="#A67C52"
        />
        <path
            d="M434.905 78.286v-3.928l2.265 1.3v3.927l-2.265-1.299Z"
            fill="#C69C6D"
        />
        <path
            d="m437.168 73.06-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M444.87 71.504v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M429.471 71.504v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m437.17 61.487-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M444.87 64.172v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M429.471 64.172v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m437.17 54.156-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M444.87 56.837v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M429.471 56.837v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m437.17 46.826-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M451.344 84.066v-3.927l-2.265 1.3v3.927l2.265-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M446.815 84.066v-3.927l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m449.079 78.84-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M456.78 77.283v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M441.381 77.283v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m449.081 67.267-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M456.78 69.952v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M441.381 69.952v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m449.081 59.936-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M456.78 62.622v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M441.381 62.622v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m449.081 52.606-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M464.495 91.755v-3.927l-2.266 1.3v3.927l2.266-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M459.966 91.755v-3.927l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m462.232 86.53-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M469.93 84.973v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M454.531 84.973v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m462.231 74.957-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M469.93 77.64v-5.599l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M454.531 77.64v-5.599l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m462.231 67.626-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M469.93 70.312v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M454.531 70.312v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m462.231 60.296-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M384.077 89.504V62.126l23.622 13.542v27.378l-23.622-13.542Z"
            fill="#DEDDE2"
        />
        <path
            d="M431.32 89.504V62.126l-23.622 13.542v27.378l23.622-13.542Z"
            fill="#ADABB9"
        />
        <path
            d="m407.698 48.584-23.622 13.542 23.622 13.541 23.622-13.541-23.622-13.542Z"
            fill="#E3DAD7"
        />
        <path
            d="M384.077 62.216V34.838l23.622 13.54v27.379l-23.622-13.541Z"
            fill="#DEDDE2"
        />
        <path
            d="M431.32 62.216V34.838l-23.622 13.54v27.379l23.622-13.541Z"
            fill="#ADABB9"
        />
        <path
            d="m407.698 21.297-23.622 13.54 23.622 13.543 23.622-13.542-23.622-13.541Z"
            fill="#D7D6DD"
        />
        <path
            d="M417.306 54.21v-4.72l5.741-3.315v4.721l4.526-2.614v5.655l-4.526 2.614v4.765l-5.741 3.315v-4.765l-4.527 2.614v-5.654l4.527-2.615ZM398.493 54.21v-4.72l-5.741-3.315v4.721l-4.526-2.614v5.655l4.526 2.614v4.765l5.741 3.315v-4.765l4.527 2.614v-5.654l-4.527-2.615Z"
            fill="#4361EE"
        />
        <path
            d="m404.311 74.217-16.905-9.621.007 22.367 16.9 9.617-.002-22.363Z"
            fill="#ADABB9"
        />
        <path
            d="m388.181 86.544 16.13 9.176v-21.5l-16.136-9.18.006 21.504Z"
            fill="#FAF8F8"
        />
        <path
            d="m411.268 74.217 16.905-9.621-.007 22.367-16.9 9.617.002-22.363Z"
            fill="#888595"
        />
        <path
            d="m427.398 86.544-16.13 9.176v-21.5l16.136-9.18-.006 21.504Z"
            fill="#E9E5F2"
        />
        <path
            d="m407.698 21.297-23.621 13.54 23.621 13.542 23.622-13.541-23.622-13.541Zm-18.448 13.54 18.448-10.575 18.448 10.576-18.448 10.575-18.448-10.575Z"
            fill="#F4EFED"
        />
        <path
            d="m505.638 86.07 62.985-36.32a13.607 13.607 0 0 1 12.304 0l62.979 36.32c3.396 1.958 3.396 5.134 0 7.092l-62.981 36.318a13.613 13.613 0 0 1-12.304 0l-62.983-36.318c-3.397-1.959-3.397-5.134 0-7.092Z"
            fill="#282739"
        />
        <path
            d="M629.333 75.932H595.35l-20.651 27.083h54.635l23.622-13.541-23.623-13.542ZM571.915 67.469h-20.133l-6.4 3.667-.518-.547-2.281 1.312 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.421-7.706-4.421Z"
            fill="#101015"
        />
        <path
            d="M560.477 74.026h-20.133l-6.4 3.667-.518-.547-2.28 1.312 2.267 1.3h1.5l5.426 3.11h20.132l7.712-4.421-7.706-4.421Z"
            fill="#101015"
        />
        <path
            d="M549.002 80.577h-20.133l-6.4 3.667-.518-.547-2.281 1.31 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.42-7.706-4.42Z"
            fill="#101015"
        />
        <path
            d="M562.173 88.28H542.04l-6.4 3.668-.518-.547-2.281 1.31 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.42-7.706-4.42Z"
            fill="#101015"
        />
        <path
            d="M504.956 87.82c-.451.45-.964 1.172-.848 2.048.115.877.836 1.74 2.03 2.428l62.984 36.32c1.494.861 3.5 1.335 5.65 1.335 2.151 0 4.157-.474 5.651-1.335l62.984-36.32a5.678 5.678 0 0 0 1.182-.884c.451-.451.964-1.173.848-2.048-.115-.878-.836-1.74-2.03-2.428l-62.984-36.32c-1.494-.861-3.5-1.335-5.651-1.335-2.15 0-4.156.474-5.65 1.335l-62.984 36.32a5.682 5.682 0 0 0-1.182.884Zm-.707-.707a6.658 6.658 0 0 1 1.389-1.043l62.985-36.32c3.396-1.96 8.903-1.96 12.299 0l62.985 36.32c3.396 1.958 3.396 5.133 0 7.092l-62.985 36.32c-3.396 1.959-8.903 1.959-12.299 0l-62.985-36.32c-2.843-1.64-3.306-4.132-1.389-6.05Z"
            fill="#DEDDE2"
        />
        <path
            d="M594.843 54.36h-20.134l-6.4 3.667-.518-.547-2.281 1.312 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.421-7.705-4.421Z"
            fill="#93A865"
        />
        <path
            d="M570.027 58.79v-3.933l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M565.491 58.79v-3.933l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m567.759 53.556-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M575.471 51.992V46.38l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M560.047 51.992V46.38l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m567.759 41.964-7.712 4.421 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M575.471 44.654V39.04l-7.712 4.422v5.611l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M560.047 44.654V39.04l7.712 4.422v5.611l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m567.759 34.62-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M575.471 37.312V31.7l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M560.047 37.312V31.7l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m567.759 27.279-7.712 4.421 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M547.125 71.898v-3.936l-2.268 1.3v3.934l2.268-1.298Z"
            fill="#A67C52"
        />
        <path
            d="M542.588 71.898v-3.936l2.268 1.3v3.934l-2.268-1.298Z"
            fill="#C69C6D"
        />
        <path
            d="m544.857 66.665-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M552.568 65.106v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M537.144 65.106v-5.611l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m544.857 55.073-7.712 4.42 7.712 4.422 7.711-4.421-7.711-4.421Z"
            fill="#75934C"
        />
        <path
            d="M552.568 57.761v-5.61l-7.712 4.42v5.612l7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M537.144 57.761v-5.61l7.712 4.42v5.612l-7.712-4.422Z"
            fill="#AAD86F"
        />
        <path
            d="m544.857 47.73-7.712 4.42 7.712 4.422 7.711-4.422-7.711-4.42Z"
            fill="#75934C"
        />
        <path
            d="M552.568 50.42V44.81l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M537.144 50.42V44.81l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m544.857 40.388-7.712 4.42 7.712 4.422 7.711-4.421-7.711-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M535.649 78.45v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M531.112 78.45v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m533.383 73.216-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M541.093 71.657v-5.613l-7.712 4.421v5.61l7.712-4.418Z"
            fill="#75934C"
        />
        <path
            d="M525.668 71.657v-5.613l7.712 4.421v5.61l-7.712-4.418Z"
            fill="#AAD86F"
        />
        <path
            d="m533.38 61.624-7.712 4.421 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M541.093 64.313v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M525.668 64.313v-5.611l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m533.38 54.28-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M541.093 56.97V51.36l-7.712 4.421v5.61l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M525.668 56.97V51.36l7.712 4.421v5.61l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m533.38 46.939-7.712 4.421 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#C7F08F"
        />
        <path
            d="M524.209 85.01v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M519.673 85.01v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m521.942 79.775-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M529.653 78.22V72.61l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M514.229 78.22V72.61l7.711 4.42v5.612l-7.711-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m521.942 68.183-7.713 4.421 7.713 4.42 7.712-4.42-7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M529.653 70.872v-5.61l-7.712 4.42v5.611l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M514.229 70.872v-5.61l7.711 4.42v5.611l-7.711-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m521.942 60.837-7.713 4.421 7.713 4.421 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M529.653 63.53V57.92l-7.712 4.42v5.613l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M514.229 63.53V57.92l7.711 4.42v5.613l-7.711-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m521.942 53.498-7.713 4.42 7.713 4.422 7.712-4.421-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M537.381 92.711v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M532.845 92.711v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m535.113 87.478-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M542.825 85.919v-5.612l-7.712 4.42v5.613l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M527.4 85.919v-5.612l7.712 4.42v5.613l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m535.115 75.886-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M542.825 78.575v-5.608l-7.712 4.421V83l7.712-4.424Z"
            fill="#75934C"
        />
        <path
            d="M527.4 78.575v-5.608l7.712 4.421V83l-7.712-4.424Z"
            fill="#AAD86F"
        />
        <path
            d="m535.115 68.543-7.712 4.42 7.712 4.422 7.712-4.422-7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M542.825 71.234v-5.611l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M527.4 71.234v-5.611l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m535.115 61.2-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M593.284 70.596v-3.928l-2.265 1.3v3.927l2.265-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M588.755 70.596v-3.928l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m591.019 65.37-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M598.719 63.813v-5.6l-7.699 4.414v5.6l7.699-4.414Z"
            fill="#75934C"
        />
        <path d="M583.32 63.813v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m591.019 53.797-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path
            d="M598.719 56.482v-5.6l-7.699 4.414v5.6l7.699-4.414Z"
            fill="#75934C"
        />
        <path d="M583.32 56.482v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m591.019 46.466-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path
            d="M598.719 49.152v-5.6l-7.699 4.414v5.6l7.699-4.414Z"
            fill="#75934C"
        />
        <path d="M583.32 49.152v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m591.019 39.136-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M606.434 78.286v-3.928l-2.265 1.3v3.927l2.265-1.299Z"
            fill="#A67C52"
        />
        <path
            d="M601.905 78.286v-3.928l2.265 1.3v3.927l-2.265-1.299Z"
            fill="#C69C6D"
        />
        <path
            d="m604.168 73.06-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M611.87 71.504v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M596.471 71.504v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m604.17 61.487-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M611.87 64.172v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M596.471 64.172v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m604.17 54.156-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M611.87 56.837v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M596.471 56.837v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m604.17 46.826-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M618.344 84.066v-3.927l-2.265 1.3v3.927l2.265-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M613.815 84.066v-3.927l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m616.079 78.84-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M623.78 77.283v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M608.381 77.283v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m616.081 67.267-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M623.78 69.952v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M608.381 69.952v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m616.081 59.936-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M623.78 62.622v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M608.381 62.622v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m616.081 52.606-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M631.495 91.755v-3.927l-2.266 1.3v3.927l2.266-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M626.966 91.755v-3.927l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m629.232 86.53-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M636.93 84.973v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M621.531 84.973v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m629.231 74.957-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M636.93 77.64v-5.599l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M621.531 77.64v-5.599l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m629.231 67.626-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M636.93 70.312v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M621.531 70.312v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m629.231 60.296-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M551.077 89.504V62.126l23.622 13.542v27.378l-23.622-13.542Z"
            fill="#DEDDE2"
        />
        <path
            d="M598.32 89.504V62.126l-23.622 13.542v27.378l23.622-13.542Z"
            fill="#ADABB9"
        />
        <path
            d="m574.698 48.584-23.622 13.542 23.622 13.541 23.622-13.541-23.622-13.542Z"
            fill="#E3DAD7"
        />
        <path
            d="M551.077 62.216V34.838l23.622 13.54v27.379l-23.622-13.541Z"
            fill="#DEDDE2"
        />
        <path
            d="M598.32 62.216V34.838l-23.622 13.54v27.379l23.622-13.541Z"
            fill="#ADABB9"
        />
        <path
            d="m574.698 21.297-23.622 13.54 23.622 13.543 23.622-13.542-23.622-13.541Z"
            fill="#D7D6DD"
        />
        <path
            d="M584.306 54.21v-4.72l5.741-3.315v4.721l4.526-2.614v5.655l-4.526 2.614v4.765l-5.741 3.315v-4.765l-4.527 2.614v-5.654l4.527-2.615ZM565.493 54.21v-4.72l-5.741-3.315v4.721l-4.526-2.614v5.655l4.526 2.614v4.765l5.741 3.315v-4.765l4.527 2.614v-5.654l-4.527-2.615Z"
            fill="#4361EE"
        />
        <path
            d="m571.311 74.217-16.905-9.621.007 22.367 16.9 9.617-.002-22.363Z"
            fill="#ADABB9"
        />
        <path
            d="m555.181 86.544 16.13 9.176v-21.5l-16.136-9.18.006 21.504Z"
            fill="#FAF8F8"
        />
        <path
            d="m578.268 74.217 16.905-9.621-.007 22.367-16.9 9.617.002-22.363Z"
            fill="#888595"
        />
        <path
            d="m594.398 86.544-16.13 9.176v-21.5l16.136-9.18-.006 21.504Z"
            fill="#E9E5F2"
        />
        <path
            d="m574.698 21.297-23.621 13.54 23.621 13.542 23.622-13.541-23.622-13.541Zm-18.448 13.54 18.448-10.575 18.448 10.576-18.448 10.575-18.448-10.575Z"
            fill="#F4EFED"
        />
        <path opacity={0.5} d="M160 12.59H74v153h86v-153Z" fill="#191822" />
        <path d="M645.757 90.09h317.822" stroke="#DEDDE2" />
        <g opacity={0.5}>
            <path
                opacity={0.5}
                d="m762.556 111.596-10.292 5.981-10.359-5.981h20.651Z"
                fill="#D7E7F7"
            />
            <path
                opacity={0.5}
                d="m766.994 116.804-31.868 18.52-3.487-2.014 31.867-18.518 3.488 2.012ZM773.656 120.652l-31.868 18.519-3.49-2.016 31.867-18.518 3.491 2.015Z"
                fill="#F8F9FC"
            />
            <path
                opacity={0.5}
                d="m773.656 120.652-17.722 10.286-3.491-2.016 17.722-10.285 3.491 2.015ZM780.16 124.407l-31.867 18.52-3.484-2.013 31.868-18.519 3.483 2.012ZM777.996 134.051l-22.465 13.055-3.491-2.015 22.465-13.055 3.491 2.015Z"
                fill="#35404D"
            />
            <path
                opacity={0.5}
                d="m762.555 111.596-10.292 5.981-10.359-5.981-26.9 15.634 46.2 26.671 37.192-21.613-35.841-20.692Zm-30.917 21.715 31.866-18.519 3.489 2.013-31.867 18.519-3.488-2.013Zm6.66 3.845 31.867-18.518 3.491 2.014-31.866 18.52-3.492-2.016Zm6.507 3.758 31.867-18.52 3.487 2.013-31.866 18.518-3.488-2.011Zm10.726 6.191-3.491-2.014 22.464-13.056 3.492 2.016-22.465 13.054Z"
                fill="#F8F9FC"
            />
            <path
                opacity={0.5}
                d="M761.2 153.901 715 127.229v1.422l46.2 26.672 37.188-21.613.005-1.423-37.193 21.614Z"
                fill="#D7E7F7"
            />
            <g opacity={0.5}>
                <path
                    opacity={0.5}
                    d="M739.518 133.311c.131.073.249.166.351.277a.896.896 0 0 1 .133.195c.065.122.09.262.07.4a1.024 1.024 0 0 1-.548.689 2.256 2.256 0 0 1-.485.207l-.1.028a3.19 3.19 0 0 1-1.682-.048 2.281 2.281 0 0 1-.536-.254 1.334 1.334 0 0 1-.247-.215c-.428-.478-.18-1.057.535-1.374.098-.043.198-.079.3-.108a3 3 0 0 1 .325-.075 2.953 2.953 0 0 1 1.884.278Z"
                    fill="#FFBF00"
                />
                <path
                    opacity={0.5}
                    d="M745.218 133.309a.739.739 0 0 0 .149.392l-5.3.48a.652.652 0 0 0-.071-.4l5.222-.472Z"
                    fill="#02567D"
                />
                <path
                    opacity={0.5}
                    d="M748.47 132.497c.133.074.253.17.356.283.475.542.1 1.208-.831 1.481a3.181 3.181 0 0 1-1.609.035 2.282 2.282 0 0 1-.606-.235 1.388 1.388 0 0 1-.352-.281 1.114 1.114 0 0 1-.062-.078.728.728 0 0 1-.149-.392c-.023-.415.358-.819 1.04-1.019a3.145 3.145 0 0 1 1.521-.05c.242.049.476.135.692.256Z"
                    fill="#E54332"
                />
                <g opacity={0.5}>
                    <path
                        opacity={0.5}
                        d="m745.585 120.355.2.384-4.175.736a.662.662 0 0 0-.074-.409l4.049-.711Z"
                        fill="#02567D"
                    />
                    <path
                        opacity={0.5}
                        d="M741.056 120.6c.133.074.253.17.355.283.05.055.092.117.126.183a.66.66 0 0 1 .074.409c-.055.368-.424.712-1.037.893a2.935 2.935 0 0 1-.349.078 3.26 3.26 0 0 1-.691.035 2.702 2.702 0 0 1-1.169-.318 1.41 1.41 0 0 1-.353-.281c-.482-.547-.112-1.212.823-1.486a3.019 3.019 0 0 1 2.221.204Z"
                        fill="#E54332"
                    />
                </g>
                <path
                    opacity={0.5}
                    d="m740.224 122.446.588 2.172a3.214 3.214 0 0 0-.685.052l-.593-2.19c.231.013.462.002.69-.034Z"
                    fill="#02567D"
                />
                <path
                    opacity={0.5}
                    d="M742.061 124.939c.132.074.251.169.353.282a.698.698 0 0 1 .062.935 1.275 1.275 0 0 1-.386.338 2.243 2.243 0 0 1-.5.212 3.097 3.097 0 0 1-2.022-.1 1.552 1.552 0 0 1-.555-.387c-.475-.543-.106-1.208.837-1.486a3.204 3.204 0 0 1 .959-.116c.437.005.866.116 1.252.322Z"
                    fill="#FFBF00"
                />
                <g opacity={0.5}>
                    <path
                        opacity={0.5}
                        d="M749.527 127.596c.098.054.187.125.264.208.355.4.075.9-.621 1.1a2.214 2.214 0 0 1-.51.087 2.375 2.375 0 0 1-.688-.063 1.737 1.737 0 0 1-.442-.173 1.077 1.077 0 0 1-.264-.21.522.522 0 0 1-.117-.552.786.786 0 0 1 .314-.358c.13-.084.273-.147.423-.188a2.216 2.216 0 0 1 1.641.149Z"
                        fill="#FFBF00"
                    />
                    <path
                        opacity={0.5}
                        d="m742.476 126.157 4.989 1.476a.786.786 0 0 0-.314.358l-5.06-1.5c.149-.085.28-.198.385-.334Z"
                        fill="#02567D"
                    />
                </g>
                <path
                    opacity={0.5}
                    d="M747.78 132.241a3.145 3.145 0 0 0-.684-.069l.877-3.246c.225.054.457.076.688.063l-.881 3.252Z"
                    fill="#02567D"
                />
                <path
                    opacity={0.5}
                    d="M736.176 128.298c.077.045.15.092.218.141.119.085.229.183.326.292.683.771.242 1.7-.969 2.167-.1.037-.2.072-.3.1a4.568 4.568 0 0 1-3.389-.309 2.182 2.182 0 0 1-.54-.43c-.17-.18-.28-.408-.315-.653a1 1 0 0 1 .034-.4c.14-.315.354-.591.624-.805.27-.213.589-.357.927-.42a4.735 4.735 0 0 1 3.107.173l.277.144Z"
                    fill="#134663"
                />
                <path
                    opacity={0.5}
                    d="M739.101 126.308a1.591 1.591 0 0 0 .469.3l-3.175 1.841a2.68 2.68 0 0 0-.496-.282l3.202-1.859ZM737.3 133.106c-.1.029-.198.065-.294.107l-.885-1-.991-1.124a4.83 4.83 0 0 0 .62-.181l1.874 2.129c-.109.017-.217.04-.324.069Z"
                    fill="#02567D"
                />
                <path
                    opacity={0.5}
                    d="M746.244 120.116a.873.873 0 0 1 .235.188c.319.355.075.792-.544.972a1.96 1.96 0 0 1-1.444-.13.949.949 0 0 1-.235-.188c-.319-.355-.075-.792.544-.972a1.955 1.955 0 0 1 1.444.13Z"
                    fill="#E54332"
                />
            </g>
        </g>
        <path
            d="m762.556 95.596-10.292 5.981-10.359-5.981h20.651Z"
            fill="#D7E7F7"
        />
        <path
            d="m766.994 100.804-31.868 18.52-3.487-2.014 31.867-18.517 3.488 2.011ZM773.656 104.652l-31.868 18.519-3.49-2.016 31.867-18.518 3.491 2.015Z"
            fill="#F8F9FC"
        />
        <path
            d="m773.656 104.652-17.722 10.286-3.491-2.016 17.722-10.285 3.491 2.015ZM780.16 108.407l-31.867 18.52-3.484-2.013 31.868-18.519 3.483 2.012ZM777.996 118.051l-22.465 13.055-3.491-2.015 22.465-13.055 3.491 2.015Z"
            fill="#35404D"
        />
        <path
            d="m762.555 95.596-10.292 5.981-10.359-5.981-26.9 15.634 46.2 26.671 37.192-21.613-35.841-20.692Zm-30.917 21.715 31.866-18.52 3.489 2.014-31.867 18.519-3.488-2.013Zm6.66 3.845 31.867-18.518 3.491 2.014-31.866 18.52-3.492-2.016Zm6.507 3.758 31.867-18.52 3.487 2.013-31.866 18.518-3.488-2.011Zm10.726 6.191-3.491-2.014 22.464-13.056 3.492 2.016-22.465 13.054Z"
            fill="#F8F9FC"
        />
        <path
            d="M761.2 137.901 715 111.229v1.422l46.2 26.672 37.188-21.613.005-1.423-37.193 21.614Z"
            fill="#D7E7F7"
        />
        <path
            d="M739.518 117.311c.131.073.249.166.351.277a.896.896 0 0 1 .133.195c.065.122.09.262.07.4a1.024 1.024 0 0 1-.548.689 2.256 2.256 0 0 1-.485.207l-.1.028a3.19 3.19 0 0 1-1.682-.048 2.281 2.281 0 0 1-.536-.254 1.334 1.334 0 0 1-.247-.215c-.428-.478-.18-1.057.535-1.374.098-.043.198-.079.3-.108a3 3 0 0 1 .325-.075 2.953 2.953 0 0 1 1.884.278Z"
            fill="#FFBF00"
        />
        <path
            d="M745.218 117.309a.739.739 0 0 0 .149.392l-5.3.48a.652.652 0 0 0-.071-.4l5.222-.472Z"
            fill="#02567D"
        />
        <path
            d="M748.47 116.497c.133.074.253.17.356.283.475.542.1 1.208-.831 1.481a3.181 3.181 0 0 1-1.609.035 2.282 2.282 0 0 1-.606-.235 1.388 1.388 0 0 1-.352-.281 1.114 1.114 0 0 1-.062-.078.728.728 0 0 1-.149-.392c-.023-.415.358-.819 1.04-1.019a3.145 3.145 0 0 1 1.521-.05c.242.049.476.135.692.256Z"
            fill="#E54332"
        />
        <path
            d="m745.585 104.355.2.384-4.175.736a.662.662 0 0 0-.074-.409l4.049-.711Z"
            fill="#02567D"
        />
        <path
            d="M741.056 104.6c.133.074.253.17.355.283.05.055.092.117.126.183a.66.66 0 0 1 .074.409c-.055.368-.424.712-1.037.893a2.935 2.935 0 0 1-.349.078 3.26 3.26 0 0 1-.691.035 2.702 2.702 0 0 1-1.169-.318 1.41 1.41 0 0 1-.353-.281c-.482-.547-.112-1.212.823-1.486a3.019 3.019 0 0 1 2.221.204Z"
            fill="#E54332"
        />
        <path
            d="m740.224 106.446.588 2.172a3.214 3.214 0 0 0-.685.052l-.593-2.19c.231.013.462.002.69-.034Z"
            fill="#02567D"
        />
        <path
            d="M742.061 108.939c.132.074.251.169.353.282a.698.698 0 0 1 .062.935 1.275 1.275 0 0 1-.386.338 2.243 2.243 0 0 1-.5.212 3.097 3.097 0 0 1-2.022-.1 1.552 1.552 0 0 1-.555-.387c-.475-.543-.106-1.208.837-1.486a3.204 3.204 0 0 1 .959-.116c.437.005.866.116 1.252.322ZM749.527 111.596c.098.054.187.125.264.208.355.4.075.9-.621 1.1a2.214 2.214 0 0 1-.51.087 2.375 2.375 0 0 1-.688-.063 1.737 1.737 0 0 1-.442-.173 1.077 1.077 0 0 1-.264-.21.522.522 0 0 1-.117-.552.786.786 0 0 1 .314-.358c.13-.084.273-.147.423-.188a2.216 2.216 0 0 1 1.641.149Z"
            fill="#FFBF00"
        />
        <path
            d="m742.476 110.157 4.989 1.476a.786.786 0 0 0-.314.358l-5.06-1.5c.149-.085.28-.198.385-.334ZM747.78 116.241a3.145 3.145 0 0 0-.684-.069l.877-3.246c.225.054.457.076.688.063l-.881 3.252Z"
            fill="#02567D"
        />
        <path
            d="M736.176 112.298c.077.045.15.092.218.141.119.085.229.183.326.292.683.771.242 1.7-.969 2.167-.1.037-.2.072-.3.1a4.568 4.568 0 0 1-3.389-.309 2.182 2.182 0 0 1-.54-.43c-.17-.18-.28-.408-.315-.653a1 1 0 0 1 .034-.4c.14-.315.354-.591.624-.805.27-.213.589-.357.927-.42a4.735 4.735 0 0 1 3.107.173l.277.144Z"
            fill="#134663"
        />
        <path
            d="M739.101 110.308a1.591 1.591 0 0 0 .469.3l-3.175 1.841a2.68 2.68 0 0 0-.496-.282l3.202-1.859ZM737.3 117.106c-.1.029-.198.065-.294.107l-.885-1-.991-1.124a4.83 4.83 0 0 0 .62-.181l1.874 2.129c-.109.017-.217.04-.324.069Z"
            fill="#02567D"
        />
        <path
            d="M746.244 104.116a.873.873 0 0 1 .235.188c.319.355.075.792-.544.972a1.96 1.96 0 0 1-1.444-.13.949.949 0 0 1-.235-.188c-.319-.355-.075-.792.544-.972a1.955 1.955 0 0 1 1.444.13Z"
            fill="#E54332"
        />
        <path d="m762.556 73.732-10.292 5.981-10.359-5.98h20.651Z" fill="#D7E7F7" />
        <path
            d="m766.994 78.941-31.868 18.52-3.487-2.014 31.867-18.518 3.488 2.012ZM773.656 82.788l-31.868 18.519-3.49-2.016 31.867-18.518 3.491 2.015Z"
            fill="#F8F9FC"
        />
        <path
            d="m773.656 82.788-17.722 10.286-3.491-2.016 17.722-10.285 3.491 2.015ZM780.16 86.543l-31.867 18.52-3.484-2.013 31.868-18.519 3.483 2.012ZM777.996 96.187l-22.465 13.055-3.491-2.015 22.465-13.055 3.491 2.015Z"
            fill="#35404D"
        />
        <path
            d="m762.555 73.732-10.292 5.981-10.359-5.98-26.9 15.633 46.2 26.671 37.192-21.613-35.841-20.692Zm-30.917 21.715 31.866-18.519 3.489 2.013-31.867 18.52-3.488-2.014Zm6.66 3.845 31.867-18.518 3.491 2.014-31.866 18.52-3.492-2.016Zm6.507 3.758 31.867-18.52 3.487 2.013-31.866 18.518-3.488-2.011Zm10.726 6.191-3.491-2.014 22.464-13.056 3.492 2.016-22.465 13.054Z"
            fill="#F8F9FC"
        />
        <path
            d="M761.2 116.038 715 89.366v1.422l46.2 26.672 37.188-21.613.005-1.423-37.193 21.614Z"
            fill="#D7E7F7"
        />
        <path
            d="M739.518 95.447c.131.073.249.167.351.277a.909.909 0 0 1 .133.195c.065.123.09.263.07.4a1.016 1.016 0 0 1-.548.69 2.221 2.221 0 0 1-.485.206l-.1.028a3.182 3.182 0 0 1-1.682-.048 2.218 2.218 0 0 1-.536-.254 1.308 1.308 0 0 1-.247-.215c-.428-.478-.18-1.057.535-1.374a2.48 2.48 0 0 1 .3-.108c.107-.03.215-.056.325-.075a2.963 2.963 0 0 1 1.884.278Z"
            fill="#FFBF00"
        />
        <path
            d="M745.218 95.445a.736.736 0 0 0 .149.392l-5.3.48a.653.653 0 0 0-.071-.4l5.222-.472Z"
            fill="#02567D"
        />
        <path
            d="M748.47 94.634c.133.074.253.17.356.283.475.542.1 1.208-.831 1.48a3.188 3.188 0 0 1-1.609.035 2.306 2.306 0 0 1-.606-.234 1.37 1.37 0 0 1-.414-.36.728.728 0 0 1-.149-.391c-.023-.415.358-.82 1.04-1.02a3.195 3.195 0 0 1 1.521-.05c.242.05.476.136.692.257Z"
            fill="#E54332"
        />
        <path
            d="m745.585 82.492.2.384-4.175.736a.66.66 0 0 0-.074-.409l4.049-.71Z"
            fill="#02567D"
        />
        <path
            d="M741.056 82.736c.133.075.253.17.355.283.05.056.092.117.126.183a.66.66 0 0 1 .074.41c-.055.367-.424.711-1.037.892a3.189 3.189 0 0 1-1.04.113 2.686 2.686 0 0 1-1.169-.318 1.408 1.408 0 0 1-.353-.28c-.482-.548-.112-1.213.823-1.487a3.02 3.02 0 0 1 2.221.204Z"
            fill="#E54332"
        />
        <path
            d="m740.224 84.582.588 2.172a3.207 3.207 0 0 0-.685.052l-.593-2.19c.231.014.462.003.69-.034Z"
            fill="#02567D"
        />
        <path
            d="M742.061 87.076c.132.074.251.169.353.282a.698.698 0 0 1 .062.935 1.283 1.283 0 0 1-.386.338 2.206 2.206 0 0 1-.5.212 3.1 3.1 0 0 1-2.022-.1 1.517 1.517 0 0 1-.555-.387c-.475-.543-.106-1.208.837-1.486a3.191 3.191 0 0 1 .959-.116 2.73 2.73 0 0 1 1.252.322ZM749.527 89.732c.098.055.187.125.264.208.355.4.075.9-.621 1.1a2.354 2.354 0 0 1-1.198.024 1.715 1.715 0 0 1-.442-.173 1.052 1.052 0 0 1-.264-.21.52.52 0 0 1-.117-.552.787.787 0 0 1 .314-.358c.13-.083.273-.146.423-.188a2.218 2.218 0 0 1 1.641.15Z"
            fill="#FFBF00"
        />
        <path
            d="m742.476 88.293 4.989 1.476a.787.787 0 0 0-.314.358l-5.06-1.5c.149-.084.28-.197.385-.334ZM747.78 94.377a3.201 3.201 0 0 0-.684-.069l.877-3.246c.225.055.457.076.688.064l-.881 3.251Z"
            fill="#02567D"
        />
        <path
            d="M736.176 90.435c.077.044.15.091.218.14.119.086.229.184.326.293.683.77.242 1.7-.969 2.167-.1.037-.2.072-.3.1-.1.028-.212.058-.32.08a4.565 4.565 0 0 1-3.069-.39 2.166 2.166 0 0 1-.54-.43c-.17-.18-.28-.407-.315-.652a1.001 1.001 0 0 1 .034-.4 2.126 2.126 0 0 1 1.551-1.225 4.74 4.74 0 0 1 3.107.173l.277.144Z"
            fill="#134663"
        />
        <path
            d="M739.101 88.444a1.544 1.544 0 0 0 .469.3l-3.175 1.841a2.68 2.68 0 0 0-.496-.282l3.202-1.859ZM737.3 95.242c-.1.03-.198.066-.294.107l-.885-1-.991-1.124a4.83 4.83 0 0 0 .62-.18l1.874 2.128c-.109.017-.217.04-.324.07Z"
            fill="#02567D"
        />
        <path
            d="M746.244 82.252a.89.89 0 0 1 .235.189c.319.355.075.791-.544.971-.48.143-.997.097-1.444-.13a.938.938 0 0 1-.235-.188c-.319-.354-.075-.791.544-.971a1.957 1.957 0 0 1 1.444.13Z"
            fill="#E54332"
        />
        <path d="m762.556 51.869-10.292 5.98-10.359-5.98h20.651Z" fill="#D7E7F7" />
        <path
            d="m766.994 57.077-31.868 18.52-3.487-2.014 31.867-18.518 3.488 2.012ZM773.656 60.925l-31.868 18.519-3.49-2.016 31.867-18.518 3.491 2.015Z"
            fill="#F8F9FC"
        />
        <path
            d="M773.656 60.925 755.934 71.21l-3.491-2.016 17.722-10.285 3.491 2.015ZM780.16 64.68 748.293 83.2l-3.484-2.014 31.868-18.519 3.483 2.013ZM777.996 74.324l-22.465 13.055-3.491-2.015 22.465-13.055 3.491 2.015Z"
            fill="#35404D"
        />
        <path
            d="m762.555 51.869-10.292 5.98-10.359-5.98-26.9 15.634 46.2 26.67 37.192-21.612-35.841-20.692Zm-30.917 21.715 31.866-18.52 3.489 2.014-31.867 18.519-3.488-2.013Zm6.66 3.845 31.867-18.518 3.491 2.014-31.866 18.52-3.492-2.016Zm6.507 3.758 31.867-18.52 3.487 2.013-31.866 18.518-3.488-2.011Zm10.726 6.19-3.491-2.013 22.464-13.056 3.492 2.016-22.465 13.054Z"
            fill="#F8F9FC"
        />
        <path
            d="M761.2 94.174 715 67.502v1.422l46.2 26.672 37.188-21.613.005-1.423L761.2 94.174Z"
            fill="#D7E7F7"
        />
        <path
            d="M739.518 73.584c.131.073.249.166.351.276a.909.909 0 0 1 .133.195c.065.123.09.263.07.4a1.016 1.016 0 0 1-.548.69 2.221 2.221 0 0 1-.485.207l-.1.027a3.182 3.182 0 0 1-1.682-.047 2.212 2.212 0 0 1-.536-.254 1.305 1.305 0 0 1-.247-.216c-.428-.477-.18-1.056.535-1.373a2.48 2.48 0 0 1 .3-.109c.107-.03.215-.055.325-.075a2.963 2.963 0 0 1 1.884.278Z"
            fill="#FFBF00"
        />
        <path
            d="M745.218 73.582a.736.736 0 0 0 .149.392l-5.3.48a.654.654 0 0 0-.071-.4l5.222-.472Z"
            fill="#02567D"
        />
        <path
            d="M748.47 72.77c.133.074.253.17.356.283.475.542.1 1.208-.831 1.48a3.181 3.181 0 0 1-1.609.035 2.302 2.302 0 0 1-.606-.234 1.369 1.369 0 0 1-.414-.36.728.728 0 0 1-.149-.391c-.023-.415.358-.82 1.04-1.02a3.201 3.201 0 0 1 1.521-.05c.242.05.476.136.692.257Z"
            fill="#E54332"
        />
        <path
            d="m745.585 60.628.2.384-4.175.736a.66.66 0 0 0-.074-.409l4.049-.71Z"
            fill="#02567D"
        />
        <path
            d="M741.056 60.873c.133.074.253.17.355.283.05.055.092.117.126.183a.66.66 0 0 1 .074.409c-.055.368-.424.712-1.037.893a3.189 3.189 0 0 1-1.04.113 2.686 2.686 0 0 1-1.169-.318 1.404 1.404 0 0 1-.353-.281c-.482-.547-.112-1.212.823-1.486a3.02 3.02 0 0 1 2.221.204Z"
            fill="#E54332"
        />
        <path
            d="m740.224 62.719.588 2.172a3.201 3.201 0 0 0-.685.052l-.593-2.19c.231.013.462.002.69-.034Z"
            fill="#02567D"
        />
        <path
            d="M742.061 65.212c.132.074.251.169.353.282a.698.698 0 0 1 .062.935 1.283 1.283 0 0 1-.386.338 2.206 2.206 0 0 1-.5.212 3.1 3.1 0 0 1-2.022-.1 1.512 1.512 0 0 1-.555-.387c-.475-.543-.106-1.208.837-1.486a3.191 3.191 0 0 1 .959-.116c.437.005.866.116 1.252.322ZM749.527 67.869c.098.054.187.124.264.208.355.4.075.9-.621 1.1a2.36 2.36 0 0 1-1.198.024 1.722 1.722 0 0 1-.442-.173 1.056 1.056 0 0 1-.264-.21.52.52 0 0 1-.117-.552.787.787 0 0 1 .314-.358c.13-.084.273-.147.423-.188a2.217 2.217 0 0 1 1.641.149Z"
            fill="#FFBF00"
        />
        <path
            d="m742.476 66.43 4.989 1.476a.787.787 0 0 0-.314.358l-5.06-1.5c.149-.085.28-.198.385-.334ZM747.78 72.514a3.201 3.201 0 0 0-.684-.07l.877-3.245c.225.054.457.076.688.063l-.881 3.252Z"
            fill="#02567D"
        />
        <path
            d="M736.176 68.57c.077.046.15.093.218.142.119.085.229.183.326.292.683.77.242 1.7-.969 2.167-.1.037-.2.072-.3.1-.1.028-.212.058-.32.08a4.564 4.564 0 0 1-3.069-.39 2.164 2.164 0 0 1-.54-.43c-.17-.18-.28-.407-.315-.652a1.001 1.001 0 0 1 .034-.4 2.127 2.127 0 0 1 1.551-1.225 4.74 4.74 0 0 1 3.107.173l.277.144Z"
            fill="#134663"
        />
        <path
            d="M739.101 66.58a1.555 1.555 0 0 0 .469.3l-3.175 1.842a2.68 2.68 0 0 0-.496-.282l3.202-1.86ZM737.3 73.379c-.1.03-.198.065-.294.107l-.885-1-.991-1.124a4.83 4.83 0 0 0 .62-.181l1.874 2.129c-.109.017-.217.04-.324.069Z"
            fill="#02567D"
        />
        <path
            d="M746.244 60.389a.89.89 0 0 1 .235.188c.319.355.075.792-.544.972-.48.143-.997.096-1.444-.13a.933.933 0 0 1-.235-.188c-.319-.355-.075-.792.544-.972a1.958 1.958 0 0 1 1.444.13Z"
            fill="#E54332"
        />
        <path d="m762.556 30.005-10.292 5.98-10.359-5.98h20.651Z" fill="#D7E7F7" />
        <path
            d="m766.994 35.214-31.868 18.52-3.487-2.014 31.867-18.518 3.488 2.012ZM773.656 39.06l-31.868 18.52-3.49-2.016 31.867-18.518 3.491 2.015Z"
            fill="#F8F9FC"
        />
        <path
            d="m773.656 39.06-17.722 10.287-3.491-2.016 17.722-10.285 3.491 2.015ZM780.16 42.816l-31.867 18.52-3.484-2.013 31.868-18.52 3.483 2.013ZM777.996 52.46l-22.465 13.055-3.491-2.015 22.465-13.055 3.491 2.015Z"
            fill="#35404D"
        />
        <path
            d="m762.555 30.005-10.292 5.98-10.359-5.98-26.9 15.634 46.2 26.67 37.192-21.612-35.841-20.692ZM731.638 51.72l31.866-18.52 3.489 2.014-31.867 18.519-3.488-2.013Zm6.66 3.845 31.867-18.518 3.491 2.014-31.866 18.52-3.492-2.016Zm6.507 3.758 31.867-18.52 3.487 2.013-31.866 18.518-3.488-2.011Zm10.726 6.19L752.04 63.5l22.464-13.056 3.492 2.016-22.465 13.054Z"
            fill="#F8F9FC"
        />
        <path
            d="M761.2 72.31 715 45.64v1.422l46.2 26.672 37.188-21.613.005-1.423L761.2 72.31Z"
            fill="#D7E7F7"
        />
        <path
            d="M739.518 51.72c.131.073.249.166.351.277a.911.911 0 0 1 .133.195c.065.122.09.262.07.4a1.015 1.015 0 0 1-.548.689 2.221 2.221 0 0 1-.485.207l-.1.028a3.18 3.18 0 0 1-1.682-.048 2.212 2.212 0 0 1-.536-.254 1.305 1.305 0 0 1-.247-.215c-.428-.478-.18-1.057.535-1.374.098-.043.198-.079.3-.108.107-.031.215-.056.325-.075a2.964 2.964 0 0 1 1.884.278Z"
            fill="#FFBF00"
        />
        <path
            d="M745.218 51.718a.736.736 0 0 0 .149.392l-5.3.48a.653.653 0 0 0-.071-.4l5.222-.472Z"
            fill="#02567D"
        />
        <path
            d="M748.47 50.906c.133.074.253.17.356.283.475.542.1 1.208-.831 1.481a3.181 3.181 0 0 1-1.609.035 2.299 2.299 0 0 1-.606-.235 1.369 1.369 0 0 1-.414-.359.728.728 0 0 1-.149-.392c-.023-.415.358-.819 1.04-1.019a3.201 3.201 0 0 1 1.521-.05c.242.049.476.135.692.256Z"
            fill="#E54332"
        />
        <path
            d="m745.585 38.765.2.384-4.175.736a.66.66 0 0 0-.074-.41l4.049-.71Z"
            fill="#02567D"
        />
        <path
            d="M741.056 39.009c.133.074.253.17.355.283.05.055.092.117.126.183a.66.66 0 0 1 .074.409c-.055.368-.424.712-1.037.893a3.183 3.183 0 0 1-1.04.113 2.684 2.684 0 0 1-1.169-.318 1.404 1.404 0 0 1-.353-.281c-.482-.547-.112-1.212.823-1.486a3.02 3.02 0 0 1 2.221.204Z"
            fill="#E54332"
        />
        <path
            d="m740.224 40.855.588 2.172a3.201 3.201 0 0 0-.685.052l-.593-2.19c.231.014.462.002.69-.034Z"
            fill="#02567D"
        />
        <path
            d="M742.061 43.348c.132.074.251.17.353.282a.698.698 0 0 1 .062.935 1.283 1.283 0 0 1-.386.338 2.202 2.202 0 0 1-.5.212 3.1 3.1 0 0 1-2.022-.1 1.508 1.508 0 0 1-.555-.387c-.475-.543-.106-1.208.837-1.486a3.198 3.198 0 0 1 .959-.116c.437.006.866.116 1.252.322ZM749.527 46.005c.098.054.187.125.264.208.355.4.075.9-.621 1.1a2.36 2.36 0 0 1-1.198.024 1.722 1.722 0 0 1-.442-.173 1.056 1.056 0 0 1-.264-.21.52.52 0 0 1-.117-.552.787.787 0 0 1 .314-.358c.13-.084.273-.147.423-.188a2.217 2.217 0 0 1 1.641.149Z"
            fill="#FFBF00"
        />
        <path
            d="m742.476 44.566 4.989 1.476a.787.787 0 0 0-.314.358l-5.06-1.5c.149-.084.28-.198.385-.334ZM747.78 50.65a3.195 3.195 0 0 0-.684-.069l.877-3.246c.225.055.457.076.688.063l-.881 3.252Z"
            fill="#02567D"
        />
        <path
            d="M736.176 46.707c.077.045.15.092.218.141.119.085.229.183.326.292.683.771.242 1.7-.969 2.167-.1.037-.2.072-.3.1-.1.028-.212.058-.32.081a4.564 4.564 0 0 1-3.069-.39 2.164 2.164 0 0 1-.54-.43c-.17-.18-.28-.408-.315-.653a1.002 1.002 0 0 1 .034-.4 2.127 2.127 0 0 1 1.551-1.225 4.74 4.74 0 0 1 3.107.173l.277.144Z"
            fill="#134663"
        />
        <path
            d="M739.101 44.717a1.55 1.55 0 0 0 .469.3l-3.175 1.84a2.68 2.68 0 0 0-.496-.282l3.202-1.858ZM737.3 51.515c-.1.03-.198.065-.294.107l-.885-1-.991-1.124a4.83 4.83 0 0 0 .62-.181l1.874 2.129c-.109.017-.217.04-.324.069Z"
            fill="#02567D"
        />
        <path
            d="M746.244 38.525c.089.05.168.113.235.188.319.355.075.792-.544.972-.48.143-.997.096-1.444-.13a.933.933 0 0 1-.235-.188c-.319-.355-.075-.792.544-.972a1.958 1.958 0 0 1 1.444.13Z"
            fill="#E54332"
        />
        <path
            d="M1063.5 150.323c58.71 0 106.3-27.431 106.3-61.268s-47.59-61.268-106.3-61.268c-58.7 0-106.293 27.43-106.293 61.268 0 33.837 47.593 61.268 106.293 61.268Z"
            fill="#282739"
        />
        <path
            d="M1063.5 149.823c58.43 0 105.8-27.207 105.8-60.768s-47.37-60.768-105.8-60.768-105.793 27.207-105.793 60.768 47.363 60.768 105.793 60.768Z"
            stroke="#DEDDE2"
        />
        <path
            d="M1067.81 6.555 1056.53.001l-23.62 13.64.14 50.523 11.28 6.554 23.63-13.643-.15-50.52Z"
            fill="#02314B"
        />
        <path
            d="m1044.33 70.72-11.28-6.555-.14-50.523 11.28 6.554.14 50.523Z"
            fill="#1F0952"
        />
        <path
            d="m1044.19 20.195-11.28-6.554 23.62-13.64 11.28 6.554-23.62 13.64Z"
            fill="#560BAD"
        />
        <path
            d="m1067.81 6.555.15 50.523-23.63 13.64-.14-50.523 23.62-13.64Z"
            fill="#331083"
        />
        <path
            d="m1062.36 15.903.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1062.39 25.222l.01 2.827-2.46 1.42-.01-2.822 2.46-1.425ZM1062.38 21.907l.01 2.834-2.46 1.42-.01-2.834 2.46-1.42ZM1065.24 20.256l.01 2.834-2.46 1.42-.01-2.834 2.46-1.42ZM1065.27 29.574l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1059.58 45.503l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1059.57 42.195l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1065.31 42.2v2.827l-2.46 1.42V43.62l2.46-1.42ZM1065.29 38.892l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1053.86 48.806l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1062.44 43.851l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1062.44 40.544v2.827l-2.46 1.42v-2.827l2.46-1.42ZM1056.69 34.529v2.827l-2.46 1.42v-2.827l2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="M1048.4 42.738c.62-.362 1.14-.075 1.14.646-.02.395-.13.779-.33 1.12-.2.343-.47.634-.81.849-.62.362-1.14.075-1.14-.652.02-.394.14-.777.33-1.118.2-.341.48-.63.81-.845Z"
            fill="#4CC9F0"
        />
        <path
            d="m1066.55 46.197.02 8.735-20.91 12.074-.02-8.735 20.91-12.074Z"
            fill="#633AC1"
        />
        <path
            d="M1048.41 48.503c.63-.362 1.14-.068 1.15.65-.02.395-.14.779-.34 1.121a2.44 2.44 0 0 1-.8.849c-.63.362-1.14.068-1.14-.652.02-.395.13-.778.33-1.12.2-.342.47-.633.8-.848Z"
            fill="#F72585"
        />
        <path
            d="m1045.61 49.089 20.91-12.074.02 8.317-20.91 12.074-.02-8.317Zm11.11-2.416-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm-2.86 1.652-.01-2.828-2.46 1.42.01 2.828 2.46-1.42Zm8.58-4.955-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm2.86-1.651-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm-5.72 3.3-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm5.73 0-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm-8.58 4.955-.01-2.827-2.46 1.419.01 2.828 2.46-1.421Zm5.72-3.3-.01-2.828-2.46 1.42.01 2.828 2.46-1.42Zm-8.58 4.954-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm5.72-3.3-.01-2.828-2.46 1.42.01 2.829 2.46-1.421Zm-11.16 6.34c.33-.216.61-.507.8-.849.2-.342.32-.726.34-1.12 0-.72-.52-1.014-1.15-.651-.33.215-.6.506-.8.848-.2.342-.31.725-.33 1.12 0 .72.51 1.014 1.14.652Zm-.01-3.548c.33-.216.61-.507.8-.849.2-.342.32-.726.34-1.12 0-.72-.52-1.013-1.15-.651-.33.215-.6.506-.8.848-.2.342-.31.725-.33 1.12 0 .72.51 1.014 1.14.652Z"
            fill="#633AC1"
        />
        <path
            d="M1048.39 39.19c.62-.362 1.14-.075 1.14.646-.02.394-.13.778-.33 1.12-.2.343-.47.633-.81.849-.62.362-1.14.075-1.14-.652.02-.394.13-.777.33-1.118.2-.341.48-.631.81-.845Z"
            fill="#F72585"
        />
        <path
            d="m1045.58 39.77 20.91-12.073.03 8.324-20.91 12.074-.03-8.324Zm11.12.893v-2.828l-2.46 1.42v2.828l2.46-1.42Zm-2.85 1.65-.01-2.827-2.46 1.42.01 2.829 2.46-1.421Zm11.44-6.605-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm-2.86 1.65-.01-2.826-2.46 1.42.01 2.828 2.46-1.421Zm-2.86 1.652-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm-2.87-1.656-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm-2.87 1.65v-2.826l-2.46 1.42.01 2.828 2.45-1.421Zm8.59-4.953-.01-2.827-2.46 1.419.01 2.828 2.46-1.421Zm2.86-1.651-.01-2.828-2.46 1.42.01 2.828 2.46-1.42Zm-5.72 3.3-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm-11.17 6.1c.34-.215.61-.506.81-.848.2-.343.31-.727.33-1.121 0-.721-.52-1.008-1.14-.646-.33.214-.61.503-.81.844-.19.341-.31.724-.33 1.118 0 .727.52 1.014 1.14.652Zm.01 3.548c.34-.215.61-.506.81-.848.2-.343.31-.727.33-1.121 0-.721-.52-1.008-1.14-.646-.33.214-.61.504-.81.844-.19.341-.31.724-.33 1.118 0 .727.52 1.014 1.14.652Z"
            fill="#633AC1"
        />
        <path
            d="m1065.28 32.882.01 2.827-2.46 1.42-.01-2.826 2.46-1.421ZM1062.42 34.533l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1059.56 36.184v2.827l-2.46 1.42v-2.827l2.46-1.42ZM1062.41 31.226l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1053.85 45.498l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="M1048.42 52.055c.63-.362 1.14-.068 1.15.651-.02.394-.14.778-.34 1.12-.19.342-.47.633-.8.849-.63.362-1.14.068-1.14-.652.02-.394.13-.778.33-1.12.2-.342.47-.632.8-.848Z"
            fill="#4CC9F0"
        />
        <path
            d="m1056.67 28.524.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1053.8 26.862l.01 2.834-2.46 1.42-.01-2.834 2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="M1048.37 33.42c.63-.362 1.14-.075 1.14.652-.02.393-.13.776-.33 1.117-.2.341-.47.63-.8.845-.63.362-1.14.075-1.15-.646.02-.394.14-.778.34-1.12.19-.342.47-.633.8-.848Z"
            fill="#4CC9F0"
        />
        <path
            d="m1045.56 30.46 20.91-12.074.02 8.317-20.91 12.073-.02-8.316Zm11.11-2.416-.01-2.833-2.46 1.419.01 2.834 2.46-1.421Zm-2.86 1.65-.01-2.832-2.46 1.42.01 2.834 2.46-1.421Zm8.58-4.953-.01-2.837-2.46 1.42.01 2.835 2.46-1.421v.003Zm2.86-1.651-.01-2.834-2.46 1.42.01 2.834 2.46-1.42Zm-5.72 3.3-.01-2.833-2.46 1.419.01 2.834 2.46-1.421Zm5.73 0-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm-8.58 4.955-.01-2.828-2.46 1.42.01 2.828 2.46-1.42Zm5.72-3.3-.01-2.827-2.46 1.42.01 2.828 2.46-1.421ZM1053.82 33l-.01-2.828-2.46 1.42.01 2.829 2.46-1.421Zm5.72-3.3-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm-11.16 6.334c.33-.215.61-.504.8-.845.2-.34.32-.724.34-1.117 0-.727-.52-1.014-1.15-.652-.33.215-.6.506-.8.848-.2.342-.31.726-.33 1.12 0 .722.51 1.009 1.14.647v-.001Zm-.01-3.548c.33-.215.61-.504.8-.845.2-.341.32-.725.34-1.118 0-.727-.52-1.014-1.15-.652-.33.215-.6.506-.8.848-.2.342-.31.726-.33 1.12 0 .722.51 1.009 1.14.647Z"
            fill="#633AC1"
        />
        <path
            d="m1065.25 23.57.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1056.7 37.833l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1059.55 32.877v2.827l-2.46 1.42v-2.827l2.46-1.42ZM1059.53 26.873l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1065.22 14.252l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1059.52 23.56l.01 2.833-2.46 1.42-.01-2.834 2.46-1.42ZM1053.81 30.176l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1056.66 25.21l.01 2.834-2.46 1.42-.01-2.834 2.46-1.42ZM1059.5 17.555l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1062.35 12.596l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1056.64 19.206l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1059.5 14.247v2.827l-2.46 1.42v-2.827l2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="M1048.36 29.87c.63-.362 1.14-.075 1.14.652a2.45 2.45 0 0 1-.33 1.118c-.2.34-.47.63-.8.845-.63.362-1.14.075-1.15-.646.02-.395.14-.779.33-1.121.2-.343.48-.633.81-.848Z"
            fill="#F72585"
        />
        <path
            d="m1053.78 20.858.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1056.63 15.899l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1053.77 17.55l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="M1048.34 24.102c.63-.362 1.15-.075 1.15.652-.02.394-.14.778-.34 1.12a2.44 2.44 0 0 1-.8.849c-.63.362-1.14.068-1.14-.652.02-.395.13-.779.33-1.121.2-.342.47-.633.8-.848Z"
            fill="#4CC9F0"
        />
        <path
            d="M1048.34 20.554c.62-.362 1.14-.075 1.14.652a2.59 2.59 0 0 1-.33 1.12c-.2.342-.48.633-.81.849-.62.362-1.14.068-1.14-.652.02-.395.13-.779.33-1.121.2-.342.47-.633.81-.848Z"
            fill="#F72585"
        />
        <path
            d="m1045.53 21.14 20.91-12.072.03 8.316-20.92 12.074-.02-8.317Zm16.83-5.718v-2.827l-2.46 1.42v2.828l2.46-1.421Zm-8.57 8.262-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm-.01-3.307-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm2.87 1.656-.01-2.827-2.46 1.422.01 2.827 2.46-1.421v-.001Zm-.01-3.307-.01-2.827-2.46 1.419.01 2.828 2.46-1.421Zm5.73 0-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm2.86-1.651v-2.828l-2.46 1.42v2.829l2.46-1.421Zm-.01-3.308V10.94l-2.46 1.42v2.828l2.46-1.421Zm-5.71 6.61-.01-2.827-2.46 1.42.01 2.828 2.46-1.421Zm-.01-3.307-.01-2.828-2.46 1.42.01 2.829 2.46-1.421Zm-11.15 9.648c.33-.216.61-.507.8-.849.2-.342.32-.726.34-1.12 0-.727-.52-1.014-1.15-.652-.33.215-.6.506-.8.848-.2.342-.31.726-.33 1.12 0 .722.51 1.015 1.14.653Zm-.01-3.548c.33-.216.61-.507.8-.849.2-.342.32-.726.34-1.12 0-.727-.52-1.014-1.15-.652-.33.215-.6.506-.8.848-.2.342-.31.726-.33 1.12 0 .722.51 1.015 1.14.653Z"
            fill="#633AC1"
        />
        <path
            d="M1065.22 10.945v2.827l-2.46 1.42v-2.827l2.46-1.42ZM1053.83 39.488l.01 2.827-2.46 1.42v-2.827l2.45-1.42ZM1053.83 36.177l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1056.72 47.154l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42ZM1056.71 43.847l.01 2.827-2.46 1.42-.01-2.827 2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="m1105.88 79.612-.01 6.3c-.01 2.593-1.71 5.181-5.11 7.157-6.85 3.982-17.99 3.982-24.89 0-3.47-2-5.2-4.628-5.19-7.253l.02-6.3c-.01 2.625 1.72 5.251 5.19 7.253 6.9 3.981 18.03 3.981 24.88 0 3.4-1.977 5.1-4.565 5.12-7.158l-.01.001Z"
            fill="#3F37C9"
        />
        <path
            d="M1100.69 72.355c6.9 3.981 6.93 10.437.08 14.415-6.84 3.978-17.99 3.981-24.88 0-6.9-3.981-6.93-10.429-.08-14.412 6.85-3.983 17.99-3.981 24.88-.003Z"
            fill="#331083"
        />
        <path
            d="m1105.88 71.8-.01 6.3c-.01 2.592-1.71 5.181-5.11 7.157-6.85 3.981-17.99 3.981-24.89 0-3.47-2-5.2-4.628-5.19-7.252l.02-6.3c-.01 2.624 1.72 5.251 5.19 7.252 6.9 3.981 18.03 3.981 24.88 0 3.4-1.976 5.1-4.565 5.12-7.157h-.01Z"
            fill="#3F37C9"
        />
        <path
            d="M1100.69 64.543c6.9 3.98 6.93 10.437.08 14.414-6.84 3.977-17.99 3.98-24.88 0-6.9-3.981-6.93-10.43-.08-14.41 6.85-3.981 17.99-3.98 24.88-.004Z"
            fill="#331083"
        />
        <path
            d="m1105.88 63.988-.01 6.3c-.01 2.592-1.71 5.181-5.11 7.157-6.85 3.982-17.99 3.982-24.89 0-3.47-2-5.2-4.63-5.19-7.253l.02-6.3c-.01 2.625 1.72 5.251 5.19 7.253 6.9 3.981 18.03 3.981 24.88 0 3.4-1.977 5.1-4.565 5.12-7.158l-.01.001Z"
            fill="#3F37C9"
        />
        <path
            d="M1100.69 56.731c6.9 3.981 6.93 10.437.08 14.414-6.84 3.977-17.99 3.981-24.88 0-6.9-3.98-6.93-10.429-.08-14.412 6.85-3.983 17.99-3.979 24.88-.002Z"
            fill="#331083"
        />
        <path
            d="m1105.88 56.176-.01 6.3c-.01 2.593-1.71 5.182-5.11 7.158-6.85 3.981-17.99 3.981-24.89 0-3.47-2-5.2-4.628-5.19-7.253l.02-6.3c-.01 2.624 1.72 5.251 5.19 7.252 6.9 3.981 18.03 3.981 24.88 0 3.4-1.976 5.1-4.565 5.12-7.157h-.01Z"
            fill="#3F37C9"
        />
        <path
            d="M1100.69 48.918c6.9 3.981 6.93 10.437.08 14.414-6.84 3.977-17.99 3.981-24.88 0-6.9-3.98-6.93-10.429-.08-14.41 6.85-3.98 17.99-3.982 24.88-.004Z"
            fill="#331083"
        />
        <path
            d="m1105.88 48.362-.01 6.3c-.01 2.592-1.71 5.18-5.11 7.157-6.85 3.98-17.99 3.98-24.89 0-3.47-2-5.2-4.628-5.19-7.252l.02-6.3c-.01 2.624 1.72 5.25 5.19 7.253 6.9 3.98 18.03 3.98 24.88 0 3.4-1.977 5.1-4.565 5.12-7.158h-.01Z"
            fill="#3F37C9"
        />
        <path
            d="M1100.69 41.106c6.9 3.98 6.93 10.437.08 14.414-6.84 3.977-17.99 3.98-24.88 0-6.9-3.981-6.93-10.431-.08-14.412 6.85-3.981 17.99-3.98 24.88-.002Z"
            fill="#331083"
        />
        <path
            d="m1105.88 40.551-.01 6.3c-.01 2.593-1.71 5.181-5.11 7.158-6.85 3.981-17.99 3.981-24.89 0-3.47-2-5.2-4.628-5.19-7.253l.02-6.3c-.01 2.624 1.72 5.251 5.19 7.252 6.9 3.981 18.03 3.981 24.88 0 3.4-1.976 5.1-4.565 5.12-7.157h-.01Z"
            fill="#3F37C9"
        />
        <path
            d="M1100.69 33.293c6.9 3.981 6.93 10.437.08 14.414-6.84 3.977-17.99 3.981-24.88 0-6.9-3.981-6.93-10.429-.08-14.412 6.85-3.983 17.99-3.98 24.88-.002Z"
            fill="#331083"
        />
        <path
            d="m1099.32 87.901-1.34-.777-.11-38.23 1.34.776.11 38.231Z"
            fill="#9CB5CC"
        />
        <path
            d="m1099.21 49.67-1.34-.776 25.08-14.475 1.33.777-25.07 14.475Z"
            fill="#D7E7F7"
        />
        <path
            d="m1124.28 35.196.11 38.23-25.07 14.476-.11-38.231 25.07-14.475Z"
            fill="#F8F9FC"
        />
        <path
            d="m1102.16 89.798-1.33-.777-.11-38.231 1.34.777.1 38.231Z"
            fill="#9CB5CC"
        />
        <path
            d="m1102.06 51.568-1.34-.777 25.07-14.475 1.34.777-25.07 14.475Z"
            fill="#D7E7F7"
        />
        <path
            d="m1127.13 37.093.1 38.23-25.07 14.476-.1-38.231 25.07-14.475Z"
            fill="#F8F9FC"
        />
        <path
            d="m1105.11 92.141-1.33-.777-.11-38.23 1.34.776.1 38.231Z"
            fill="#9CB5CC"
        />
        <path
            d="m1105.01 53.911-1.34-.777 25.07-14.475 1.34.777-25.07 14.475Z"
            fill="#D7E7F7"
        />
        <path
            d="m1130.08 39.436.11 38.231-25.08 14.475-.1-38.231 25.07-14.475Z"
            fill="#F8F9FC"
        />
        <path
            d="m1128.55 60.092.01 2.3-21.9 12.636v-2.3l21.89-12.636ZM1128.52 50.302v2.3l-21.89 12.64-.01-2.3 21.9-12.64Z"
            fill="#9CB5CC"
        />
        <path
            d="m1121.41 49.497.01 2.3-14.8 8.545-.01-2.3 14.8-8.545Z"
            fill="#FA7564"
        />
        <path
            d="m1128.53 55.2.01 2.3-21.89 12.637-.01-2.3 21.89-12.638ZM1128.57 69.89l.01 2.3-21.89 12.64-.01-2.3 21.89-12.64ZM1128.56 64.991l.01 2.3-21.9 12.64v-2.3l21.89-12.64Z"
            fill="#9CB5CC"
        />
        <path
            d="m1112.09 115.815-.67-.3-.07-.034 1.81 1.046.07.034.67.3c.02 0 .03.004.04.011l-1.81-1.046a.062.062 0 0 0-.04-.011ZM1110.1 120.903c0-.018-.01-.034-.02-.049a.094.094 0 0 0-.04-.036l-1.81-1.046c.01.009.03.022.04.036.01.015.01.032.02.049l.37.732c.01.015.01.03.02.043.01.013.02.025.03.033l1.81 1.046a.197.197 0 0 1-.03-.033c-.01-.013-.01-.028-.02-.043l-.37-.732Z"
            fill="#331083"
        />
        <path
            d="M1112.32 112.222a.076.076 0 0 0-.04-.012.1.1 0 0 0-.04.003.105.105 0 0 0-.05.022.152.152 0 0 0-.05.035l-.69.446.38-.709c.01-.04.04-.078.06-.112a.386.386 0 0 1 .1-.084c.02-.01.04-.018.06-.023a.134.134 0 0 1 .04 0l.78.087c.02.002.03.005.04.011l-1.81-1.046a.102.102 0 0 0-.04-.011l-.78-.087a.134.134 0 0 0-.04 0 .25.25 0 0 0-.06.024.347.347 0 0 0-.16.195l-.59 1.123-.07.111-1.19-.689c-.01-.007-.03-.011-.04-.013a.135.135 0 0 0-.04.003.116.116 0 0 0-.05.022.152.152 0 0 0-.05.035l-.88.757c-.02.015-.03.031-.05.048a.615.615 0 0 0-.08.14.432.432 0 0 0-.01.16l.06 1v.107c-.03.042-.07.084-.1.127-.16.193-.3.393-.44.6a.651.651 0 0 1-.09.074.205.205 0 0 1-.07.027.134.134 0 0 1-.04 0l-.84.111a.267.267 0 0 0-.04 0 .219.219 0 0 0-.06.025.367.367 0 0 0-.1.084.52.52 0 0 0-.07.115l-.46 1.169c-.05.113-.03.214.03.249l.76.441c-.05.234-.09.47-.11.709a.598.598 0 0 1-.16.242l-.82.9a.165.165 0 0 0-.05.048.616.616 0 0 0-.08.137c-.01.051-.01.105-.01.157l.22.893c0 .014.01.028.02.04s.02.022.03.029l1.3.752-.1.38c-.04.113-.03.216.03.251l1.81 1.046c-.06-.035-.07-.138-.03-.251l.32-1.153a.306.306 0 0 0 .01-.248 1.532 1.532 0 0 1-.35-.415l-1.23-.708.74-.817a.892.892 0 0 0 .06-.062.438.438 0 0 0 .1-.181c.02-.273.07-.543.13-.81l-.83-.477c0-.038.01-.075.02-.111l.47-1.169c.01-.042.04-.08.06-.115.03-.034.07-.062.1-.084a.15.15 0 0 1 .1-.025l.84-.111a.21.21 0 0 0 .05 0c.02-.006.04-.015.07-.027.03-.02.06-.046.08-.075.14-.207.29-.407.44-.6.04-.043.07-.085.11-.127v-.107l-.06-1a.291.291 0 0 1 .01-.16c.01-.052.04-.1.08-.14.01-.017.03-.033.04-.048l.56-.479.99.569c.02.013.05.018.07.014.2-.094.41-.166.62-.214h.01l.07-.113.07-.13 1.65.955.09-.054.9-.585c.02-.013.03-.025.05-.035.02-.01.04-.018.06-.023.02-.007.05-.003.08.01l-1.82-1.043Z"
            fill="#331083"
        />
        <path
            d="m1111.17 115.538-1.81-1.046c.09.056.16.129.22.215s.1.183.12.285c.05.364.02.734-.09 1.084-.1.351-.28.675-.53.95-.1.12-.2.231-.32.333-.1.086-.2.162-.32.228a1.28 1.28 0 0 1-.39.158.727.727 0 0 1-.53-.066l1.81 1.045c.16.089.35.113.53.067.14-.032.27-.085.39-.158.12-.066.22-.142.32-.228.12-.101.23-.213.32-.334.25-.274.43-.598.53-.949.11-.351.14-.72.09-1.084a.748.748 0 0 0-.12-.285.647.647 0 0 0-.22-.215Z"
            fill="#331083"
        />
        <path
            d="M1114.4 114.229c.01.065 0 .13-.02.19a.476.476 0 0 1-.12.156l-.82.9a.58.58 0 0 0-.15.245c-.02.272-.07.542-.13.807l.07.034.67.3c.1 0 .12.125.07.257l-.46 1.169a.498.498 0 0 1-.16.2.17.17 0 0 1-.1.025l-.85.118a.186.186 0 0 0-.11.03.385.385 0 0 0-.1.078c-.17.25-.34.49-.54.721v.1l.06 1c.01.065 0 .13-.02.19a.482.482 0 0 1-.12.155l-.87.761c-.02.011-.03.021-.04.03-.09.051-.17.032-.19-.06l-.38-.732c0-.015 0-.03-.01-.043a.272.272 0 0 0-.03-.035l-.04-.02a.168.168 0 0 0-.05-.002c-.2.096-.42.17-.64.22l-.06.11-.6 1.12a.374.374 0 0 1-.16.2.174.174 0 0 1-.1.026l-.77-.09c-.09-.012-.13-.131-.07-.263l.31-1.153a.308.308 0 0 0 .02-.248 1.773 1.773 0 0 1-.36-.415l-.09.054-.9.585c-.02.013-.03.024-.05.034-.08.048-.16.024-.18-.058l-.22-.893a.4.4 0 0 1 .02-.188c.03-.06.07-.113.12-.154l.82-.9a.555.555 0 0 0 .15-.243c.03-.273.07-.543.13-.81l-.07-.031-.67-.3c-.09-.012-.12-.128-.07-.26l.47-1.169a.427.427 0 0 1 .16-.2.201.201 0 0 1 .1-.029l.84-.111c.04.001.08-.009.12-.03.03-.02.06-.046.08-.075.17-.252.35-.494.55-.724v-.107l-.06-1a.416.416 0 0 1 .02-.192.352.352 0 0 1 .11-.157l.88-.757c.02-.014.03-.025.05-.035.09-.049.16-.024.18.058l.37.736c.01.031.03.059.05.077.03.019.06.027.09.023.2-.096.42-.169.63-.217l.07-.113.59-1.123a.427.427 0 0 1 .16-.2.17.17 0 0 1 .1-.025l.78.087c.09.012.12.128.07.266l-.32 1.153a.354.354 0 0 0-.02.248c.15.115.27.256.36.415l.09-.054.9-.585c.02-.013.03-.025.05-.035.09-.05.17-.026.18.059l.23.899Zm-3.83 4.178c.34-.286.6-.652.77-1.065.16-.413.22-.86.17-1.302-.14-.6-.68-.751-1.27-.41-.11.064-.21.138-.31.221-.34.288-.6.655-.77 1.07-.16.414-.22.863-.18 1.306.16.6.69.749 1.28.408.11-.066.21-.142.31-.228Z"
            fill="#560BAD"
        />
        <path
            d="m1116.89 101.719-.96-.422-.1-.049 1.81 1.046.1.049.96.422c.02.002.04.008.05.017l-1.81-1.046c-.01-.01-.03-.015-.05-.017ZM1113.31 108.491a.098.098 0 0 0-.03-.068.146.146 0 0 0-.05-.052l-1.81-1.046c.02.014.04.031.05.052.02.02.03.044.03.068l.53 1.035c0 .022.01.042.02.06.02.018.03.034.05.045l1.81 1.046a.183.183 0 0 1-.07-.1l-.53-1.04ZM1117.21 96.639a.158.158 0 0 0-.11-.014.38.38 0 0 0-.09.034.587.587 0 0 0-.06.044l-1.27.825-.13.083 1.81 1.04.13-.081 1.27-.826c.02-.016.04-.03.06-.043a.372.372 0 0 1 .09-.034c.03-.01.07-.005.11.014l-1.81-1.042ZM1114.83 100.894l-1.81-1.042c.13.079.24.182.32.304.08.122.14.26.17.405a3.662 3.662 0 0 1-.88 2.878c-.14.172-.3.331-.46.476-.14.12-.29.227-.44.319-.18.103-.36.179-.56.223-.26.065-.53.031-.76-.094l1.81 1.046c.24.125.51.158.76.093.2-.044.38-.119.56-.222.15-.092.3-.199.44-.319.16-.145.32-.304.46-.476a3.662 3.662 0 0 0 .88-2.878 1.19 1.19 0 0 0-.17-.407 1.008 1.008 0 0 0-.32-.306Z"
            fill="#4895EF"
        />
        <path
            d="m1109.69 107.652-1.73-1 1.05-1.15a.426.426 0 0 0 .08-.085.852.852 0 0 0 .14-.265c.03-.385.09-.767.18-1.142l-1.17-.678c0-.054.01-.109.02-.16l.67-1.651a.57.57 0 0 1 .1-.167.53.53 0 0 1 .12-.112c.03-.014.05-.025.08-.031a.151.151 0 0 1 .06 0l1.2-.173c.03.004.05.004.07 0a.299.299 0 0 0 .1-.039.577.577 0 0 0 .13-.1c.2-.306.42-.602.65-.886.03-.045.07-.09.11-.134v-.151l-.09-1.417a.571.571 0 0 1 .02-.225c.02-.073.06-.14.11-.197a.358.358 0 0 1 .07-.069l.78-.679 1.4.8c.03.018.07.025.1.02.29-.132.59-.233.9-.3l.09-.157.84-1.589a.589.589 0 0 1 .23-.285c.03-.015.05-.026.08-.033a.208.208 0 0 1 .06 0l1.1.129a.1.1 0 0 1 .05.016l-1.81-1.045c-.01-.01-.03-.015-.05-.017l-1.1-.129a.208.208 0 0 0-.06 0 .204.204 0 0 0-.08.034.55.55 0 0 0-.23.284l-.84 1.589-.08.154-1.69-.977a.159.159 0 0 0-.11-.013.352.352 0 0 0-.09.032.699.699 0 0 0-.06.043l-1.24 1.077a.656.656 0 0 0-.16.222.613.613 0 0 0-.04.268l.09 1.417v.151l-.11.134c-.23.284-.45.58-.65.887a.586.586 0 0 1-.13.1.283.283 0 0 1-.1.039.203.203 0 0 1-.07 0l-1.2.173a.201.201 0 0 0-.06 0c-.03.006-.05.017-.08.031a.488.488 0 0 0-.12.112.576.576 0 0 0-.1.168l-.67 1.65c-.06.165-.04.307.05.356l1.07.622c-.07.329-.12.664-.15 1a.685.685 0 0 1-.14.265.426.426 0 0 1-.08.085l-1.16 1.27-.06.067a.51.51 0 0 0-.11.198.435.435 0 0 0-.02.226l.31 1.253c.01.022.01.043.03.061a.11.11 0 0 0 .04.046l1.81 1.045a.104.104 0 0 1-.04-.046c-.02-.018-.02-.038-.03-.06l-.31-1.253a.575.575 0 0 1 .02-.226.51.51 0 0 1 .11-.198c.02-.024.04-.046.06-.067l.09-.092c.12.194.28.37.45.52.04.113.03.237-.02.345l-.44 1.631c-.07.163-.05.309.04.359l1.81 1.046c-.09-.051-.11-.2-.04-.359l.44-1.631a.459.459 0 0 0 .02-.345c-.2-.169-.37-.369-.51-.592Z"
            fill="#4895EF"
        />
        <path
            d="M1119.4 99.044a.61.61 0 0 1-.03.269.642.642 0 0 1-.16.221l-1.16 1.274a.71.71 0 0 0-.22.346c-.03.384-.09.766-.19 1.14l.1.049.96.422c.13.011.17.178.1.366l-.66 1.654a.527.527 0 0 1-.23.279.22.22 0 0 1-.14.036l-1.19.17a.296.296 0 0 0-.17.043.883.883 0 0 0-.12.1c-.23.357-.49.699-.77 1.024l.01.147.08 1.417c.01.09 0 .182-.03.266a.633.633 0 0 1-.16.218l-1.25 1.077a.251.251 0 0 1-.07.05c-.12.07-.22.038-.25-.086l-.53-1.035a.167.167 0 0 0-.07-.109.151.151 0 0 0-.12-.031c-.29.133-.59.233-.9.3l-.09.161-.84 1.589a.657.657 0 0 1-.23.284.24.24 0 0 1-.14.034l-1.1-.125c-.13-.022-.17-.188-.09-.376l.44-1.631a.459.459 0 0 0 .02-.345 2.27 2.27 0 0 1-.5-.593l-.13.073-1.27.829c-.02.019-.05.035-.07.049-.12.069-.23.038-.26-.088l-.31-1.253a.504.504 0 0 1 .04-.27.513.513 0 0 1 .15-.221l1.16-1.27a.718.718 0 0 0 .22-.35c.03-.385.09-.766.18-1.142l-.09-.047-.96-.418c-.13-.015-.17-.178-.1-.373l.66-1.65a.646.646 0 0 1 .23-.28.212.212 0 0 1 .14-.033l1.2-.173a.23.23 0 0 0 .16-.042.577.577 0 0 0 .13-.1c.23-.355.49-.695.76-1.02v-.15l-.09-1.418a.62.62 0 0 1 .04-.27.524.524 0 0 1 .16-.22l1.25-1.077c.01-.016.03-.03.06-.043.12-.07.23-.04.26.088l.52 1.036c.01.044.04.083.07.11a.18.18 0 0 0 .13.03c.28-.133.59-.233.9-.3l.08-.157.84-1.589a.537.537 0 0 1 .23-.285.24.24 0 0 1 .14-.037l1.1.13c.13.014.17.183.1.371l-.45 1.634a.458.458 0 0 0-.02.345c.2.168.37.368.51.593l.13-.082 1.27-.826c.02-.016.04-.03.06-.043.12-.072.23-.042.27.08l.3 1.254Zm-5.42 5.914c.48-.405.86-.923 1.09-1.508.23-.585.32-1.219.25-1.846-.21-.849-.97-1.061-1.8-.579-.16.093-.31.2-.44.321-.49.405-.86.923-1.09 1.507a3.752 3.752 0 0 0-.25 1.844c.21.848.97 1.061 1.8.58.15-.092.3-.199.44-.319Z"
            fill="#4CC9F0"
        />
        <path
            d="m1129.41 109.552 1.81 1.046c.01.004.02.009.04.015l-1.82-1.046a.21.21 0 0 0-.03-.015Z"
            fill="#D43E3E"
        />
        <path
            d="M1130.43 102.397a.198.198 0 0 0-.15-.017.494.494 0 0 0-.16.067l-1.78.939a.423.423 0 0 1-.13.056l1.81 1.046a.448.448 0 0 0 .13-.056l1.78-.939c.05-.031.1-.054.16-.067.05-.014.1-.008.15.016l-1.81-1.045ZM1123.62 117.623a.256.256 0 0 0-.04-.12.231.231 0 0 0-.09-.091l-1.81-1.045c.04.023.07.054.09.09.02.036.04.077.04.12l.54 1.584.03.1c.02.03.04.056.07.076l1.81 1.046c-.02-.02-.05-.046-.07-.076a3.159 3.159 0 0 1-.03-.1l-.54-1.584ZM1126.33 107.016l-1.81-1.046c.21.137.38.32.51.536.12.215.19.456.21.704a5.218 5.218 0 0 1-1.26 3.642c-.26.319-.55.605-.88.85-.11.08-.22.155-.34.223-.23.139-.49.24-.76.3-.34.087-.71.042-1.02-.127l1.81 1.046c.31.169.68.214 1.03.127.26-.06.52-.161.75-.3.12-.068.23-.143.34-.223.33-.246.63-.531.88-.85a5.208 5.208 0 0 0 1.26-3.638 1.742 1.742 0 0 0-.21-.707c-.13-.216-.3-.4-.51-.537ZM1119.1 115.671l-1.81-1.046c.14.344.33.664.57.948.04.163.01.334-.06.483l-.78 2.235c-.11.23-.1.457.03.532l1.81 1.045c-.13-.074-.14-.3-.03-.531l.78-2.235c.08-.149.1-.32.06-.483a3.52 3.52 0 0 1-.57-.948ZM1123.92 101.731a.214.214 0 0 1-.1-.03l1.81 1.046c.03.017.06.027.1.03a4.72 4.72 0 0 1 1.19-.242l.13-.211 1.27-2.086a.71.71 0 0 1 .12-.177.618.618 0 0 1 .17-.157c.04-.02.08-.035.11-.044.04-.01.08-.01.11 0l1.39.419c.02.004.03.01.05.017l-1.82-1.044c-.01-.007-.03-.013-.04-.017l-1.39-.42a.227.227 0 0 0-.11 0 .34.34 0 0 0-.11.045.652.652 0 0 0-.18.157c-.04.054-.08.114-.11.177l-1.27 2.087-.14.21a4.713 4.713 0 0 0-1.18.24Z"
            fill="#B5179E"
        />
        <path
            d="M1121.2 106.386a.65.65 0 0 0 .13-.093c.11-.147.22-.292.34-.434.24-.3.5-.591.76-.865a.483.483 0 0 0 .01-.207l.08-2.036a.737.737 0 0 1 .18-.531c.03-.045.08-.085.12-.12l1.73-1.267c.02-.013.03-.024.05-.034a.319.319 0 0 1 .11-.045.22.22 0 0 1 .15.018l-1.81-1.046a.213.213 0 0 0-.15-.018.319.319 0 0 0-.11.045c-.02.01-.03.021-.05.034l-1.73 1.265c-.04.035-.09.075-.12.12a.793.793 0 0 0-.19.531l-.07 2.036c.01.069.01.139-.01.207-.26.274-.52.564-.77.865-.11.142-.22.287-.33.434-.04.035-.09.067-.13.093a.395.395 0 0 1-.13.053.26.26 0 0 1-.13 0l-1.54-.01a.319.319 0 0 0-.23.045.655.655 0 0 0-.18.155c-.04.054-.08.113-.11.176l-1.05 2.207c-.11.239-.09.464.04.536l.1.055 1.11.758.12.084c-.17.519-.29 1.049-.38 1.586-.04.111-.1.214-.17.305-.05.054-.1.103-.15.145l-1.65 1.565c-.04.035-.08.075-.12.12a.737.737 0 0 0-.18.531l.24 1.856c0 .035.01.069.03.099.01.03.04.055.07.074l1.81 1.046c-.03-.019-.06-.044-.07-.074a.177.177 0 0 1-.03-.099l-.24-1.856a.737.737 0 0 1 .31-.651l1.64-1.565c.05-.042.1-.091.15-.145.07-.091.13-.194.17-.305.09-.537.21-1.067.38-1.586l-.12-.084-1.17-.8-.05-.029c-.11-.08-.13-.293-.02-.523l1.05-2.208a.676.676 0 0 1 .11-.175.655.655 0 0 1 .18-.155.319.319 0 0 1 .11-.045c.03-.01.07-.01.11 0l1.54.01a.26.26 0 0 0 .13 0 .411.411 0 0 0 .13-.048Z"
            fill="#B5179E"
        />
        <path
            d="M1132.58 105.469c0 .125-.02.249-.07.362a.885.885 0 0 1-.24.289l-1.64 1.571a.92.92 0 0 0-.32.444c-.09.537-.22 1.067-.38 1.586l.12.09 1.17.791c.16.052.19.29.07.551l-1.05 2.208a.738.738 0 0 1-.29.331.312.312 0 0 1-.1.044.323.323 0 0 1-.12-.002l-1.54-.01a.348.348 0 0 0-.27.05.973.973 0 0 0-.12.093c-.34.459-.71.893-1.11 1.3a.486.486 0 0 0-.01.208l-.07 2.036c0 .125-.02.249-.08.363a.74.74 0 0 1-.23.288l-1.72 1.273c-.24.138-.39.072-.42-.126l-.54-1.584a.25.25 0 0 0-.07-.163.25.25 0 0 0-.16-.078c-.38.132-.78.215-1.18.248l-.14.205-1.27 2.087a.737.737 0 0 1-.29.333.253.253 0 0 1-.1.044.323.323 0 0 1-.12-.001l-1.39-.413c-.16-.049-.19-.3-.07-.548l.78-2.235c.08-.149.1-.32.06-.483a3.52 3.52 0 0 1-.57-.948.561.561 0 0 0-.13.056l-1.77.943c-.23.138-.39.075-.42-.123l-.24-1.856c0-.125.03-.25.08-.363a.74.74 0 0 1 .23-.288l1.64-1.565a.955.955 0 0 0 .32-.45c.09-.537.22-1.067.38-1.586l-.11-.084-1.18-.8c-.15-.046-.19-.291-.06-.552l1.04-2.208a.87.87 0 0 1 .29-.33.257.257 0 0 1 .11-.045.303.303 0 0 1 .12.003l1.54.01a.355.355 0 0 0 .26-.05.693.693 0 0 0 .13-.093c.34-.456.71-.891 1.1-1.3a.483.483 0 0 0 .01-.207l.08-2.036a.756.756 0 0 1 .07-.363.74.74 0 0 1 .23-.288l1.73-1.267c.02-.013.03-.024.05-.034.18-.1.33-.044.36.154l.55 1.584c0 .06.02.118.06.162.04.044.1.072.16.078.38-.133.78-.214 1.19-.242l.13-.211 1.28-2.086a.788.788 0 0 1 .28-.334.359.359 0 0 1 .11-.043.27.27 0 0 1 .11 0l1.39.42c.17.043.2.29.08.542l-.78 2.234c-.08.149-.1.32-.07.484.24.283.43.603.57.947.05-.012.09-.03.13-.054l1.78-.939c.22-.136.38-.078.41.12l.24 1.856Zm-7.67 7.275a5.382 5.382 0 0 0 1.61-1.985c.37-.781.55-1.639.53-2.503-.18-1.351-1.26-1.782-2.5-1.063-.11.068-.23.142-.34.222a5.423 5.423 0 0 0-2.13 4.495c.18 1.345 1.26 1.775 2.49 1.057.12-.068.23-.143.34-.223Z"
            fill="#F72585"
        />
        <path
            d="m1069.74 118.993-30.96 17.994a5.852 5.852 0 0 1-5.3 0l-16.6-9.584 4.48-2.6v-1.219l3.07 1.764.44-.253.01-2.563-.01 3.07 6.7 3.843.42-.245v.492l8.85 5.077 4.1-2.392v-1.09l.94.538 1.37-.8 2.72-1.589 4.75-2.775v-1.374l1.19.683 4.09-2.4v-1.058l.91.527 4.1-2.4.01-3.069-4.29-2.463-.82.481v-.948l-4.29-2.465-.82.479v-.947l-4.29-2.463-.82.481v-.949l-4.29-2.463-.82.479v-.946l-4.28-2.463-.82.479v-.952l-4.3-2.459-.81.479v-.952l-4.3-2.462-.81.479v-.946l-4.3-2.466-.81.479v-.947l-4.3-2.463-4.09 2.393v1.062l-1.03-.59 2.4-1.377.01-3.07-4.29-2.462-4.1 2.393v1.059l-.91-.524-4.1 2.395v1.064l-.92-.53-4.097 2.396v1.065l-.918-.53-4.091 2.396v1.094l-.946-.543-4.092 2.392-.008 3.069 9.084 5.219.538-.314.006-2.448-.008 3.07 6.092 3.5-4.43 2.571v1.226l-20.3-11.72a1.88 1.88 0 0 1-1.1-1.545l-.009 3.068a1.882 1.882 0 0 0 1.1 1.547l53.839 31.08a5.864 5.864 0 0 0 5.3 0l30.96-18a1.873 1.873 0 0 0 1.09-1.524v-3.069c-.03.328-.14.643-.33.911-.2.269-.45.482-.76.617Z"
            fill="#331083"
        />
        <path
            d="m1024.19 94.12-4.1 2.394-4.29-2.464 4.09-2.393 4.3 2.463ZM1018.4 96.603l-4.09 2.4-10.56-6.065 4.1-2.394 10.55 6.059ZM1029.3 97.054l-4.1 2.39-4.29-2.462 4.09-2.394 4.3 2.466ZM1010.69 97.98l-4.1 2.395-7.865-4.516 4.095-2.394 7.87 4.516ZM1034.4 99.983l-4.1 2.393-4.29-2.461 4.1-2.393 4.29 2.461ZM1015.53 100.766l-4.1 2.393-4.29-2.46 4.1-2.394 4.29 2.461ZM1028.37 102.333l-4.09 2.394-4.29-2.461 4.1-2.395 4.28 2.462ZM1008.37 102.465l-4.1 2.392-10.558-6.062 4.096-2.394 10.562 6.064ZM1039.51 102.914l-4.1 2.395-4.29-2.462 4.1-2.392 4.29 2.459ZM1020.36 103.534l-4.1 2.394-4.29-2.46 4.1-2.393 4.29 2.459ZM1001.86 104.561l-4.103 2.392-9.084-5.217 4.091-2.392 9.096 5.217ZM1033.26 105.137l-4.1 2.394-4.28-2.463 4.1-2.393 4.28 2.462ZM1013.25 105.265l-4.1 2.394-4.29-2.463 4.1-2.394 4.29 2.463ZM1025.18 106.309l-4.1 2.393-4.29-2.464 4.1-2.393 4.29 2.464ZM1018.02 108.006l-4.1 2.393-4.29-2.463 4.1-2.39 4.29 2.46ZM1049.71 108.781l-4.09 2.392-4.29-2.462 4.1-2.393 4.28 2.463ZM1009.1 108.716l-4.1 2.394-6.704-3.849 4.094-2.394 6.71 3.849ZM1030 109.077l-4.1 2.393-4.28-2.463 4.1-2.393 4.28 2.463ZM1022.84 110.776l-4.09 2.394-4.29-2.463 4.1-2.393 4.28 2.462ZM1054.82 111.712l-4.1 2.393-4.29-2.461 4.1-2.394 4.29 2.462ZM1034.83 111.847l-4.1 2.395-4.29-2.46 4.1-2.393 4.29 2.458ZM1047.9 113.546l-4.09 2.393-4.3-2.461 4.1-2.394 4.29 2.462ZM1027.61 113.517l-4.1 2.393-4.28-2.461 4.1-2.393 4.28 2.461ZM1059.93 114.645l-4.1 2.393-4.29-2.466 4.1-2.392 4.29 2.465ZM1065.03 117.568l-4.1 2.393-4.29-2.466 4.1-2.393 4.29 2.466ZM1039.65 114.62l-4.1 2.4-4.28-2.466 4.1-2.393 4.28 2.459ZM1052.78 116.349l-4.1 2.394-4.29-2.461 4.1-2.4 4.29 2.467ZM1032.6 116.38l-4.1 2.393-4.29-2.464 4.1-2.393 4.29 2.464ZM1044.47 117.391l-4.09 2.394-4.29-2.465 4.1-2.392 4.28 2.463ZM1037.37 119.12l-4.1 2.393-4.28-2.464 4.09-2.39 4.29 2.461ZM1049.3 120.162l-4.1 2.392-4.29-2.462 4.1-2.394 4.29 2.464ZM1060.02 120.504l-4.1 2.4-6.65-3.816 4.1-2.392 6.65 3.808ZM1042.19 121.89l-4.1 2.393-4.29-2.463 4.1-2.393 4.29 2.463ZM1021.37 121.735l-6.07 3.53-15.35-8.861 6.08-3.528 15.34 8.859ZM1035.68 123.99l-4.1 2.39-6.7-3.845 4.1-2.394 6.7 3.849Z"
            fill="#F8F9FC"
        />
        <path
            d="m1054.73 123.588-4.74 2.773-2.73 1.591-1.37.8-7.24-4.156 4.1-2.393 2.23 1.278 4.74-2.773 5.01 2.88Z"
            fill="#F8F9FC"
        />
        <path
            d="M1069.73 115.925c1.46.844 1.47 2.223.01 3.068l-30.96 17.994a5.852 5.852 0 0 1-5.3 0l-53.834-31.079c-1.462-.845-1.47-2.225-.016-3.072l30.96-17.992a5.877 5.877 0 0 1 2.65-.635c.93 0 1.83.218 2.65.635l53.84 31.081Zm-54.43 9.339 6.07-3.529-15.35-8.86-6.07 3.528 15.35 8.861Zm-9.69-13.8 18.83 10.82 4.1-2.393-18.84-10.82-4.09 2.393Zm41.65 16.5 2.73-1.591 4.74-2.773-5.01-2.878-4.75 2.773-2.22-1.278-4.1 2.393 7.24 4.156 1.37-.8v-.002ZM1018.4 96.61l-10.56-6.064-4.1 2.395 10.56 6.065 4.1-2.4v.004Zm-10.03 5.861-10.563-6.065-4.091 2.395 10.554 6.063 4.1-2.392v-.001Zm-19.694-.727 9.084 5.216 4.1-2.391-9.088-5.218-4.092 2.392-.004.001Zm43.334 24.887 8.84 5.079 4.09-2.391-8.84-5.082-4.09 2.394Zm-21.32-28.64-7.87-4.516-4.096 2.394 7.866 4.516 4.1-2.395v.001Zm-12.394 9.278 6.704 3.849 4.1-2.393-6.7-3.85-4.098 2.394h-.006Zm26.584 15.272 6.7 3.846 4.1-2.391-6.7-3.849-4.1 2.395v-.001Zm24.4-3.45 6.64 3.815 4.1-2.4-6.65-3.812-4.1 2.392.01.005Zm-8.36 1.002 4.29 2.461 4.1-2.391-4.29-2.465-4.1 2.395Zm-18.07-9.317-4.29-2.462-4.1 2.393 4.29 2.462 4.1-2.393Zm16.66-7.862-4.29-2.462-4.1 2.391 4.29 2.462 4.1-2.395v.004Zm-6.91 13.466-4.29-2.465-4.1 2.393 4.29 2.465 4.1-2.393Zm15.89-2.495-4.09 2.4 4.29 2.461 4.1-2.395-4.29-2.463-.01-.003Zm-24.3-19.766-4.3-2.467-4.09 2.393 4.29 2.463 4.1-2.393v.004Zm-.1 5.751-4.1 2.395 4.3 2.461 4.09-2.393-4.29-2.462v-.001Zm-10.83 5.395-4.29-2.462-4.1 2.393 4.28 2.463 4.1-2.395.01.001Zm30.36 5.818-4.1 2.395 4.29 2.461 4.09-2.392-4.29-2.463.01-.001Zm-4.88-2.8-4.1 2.392 4.29 2.462 4.1-2.393-4.29-2.461Zm-4.88-2.8-4.1 2.39 4.29 2.466 4.09-2.4-4.29-2.46.01.004Zm31.18 12.1-4.29-2.463-4.1 2.393 4.29 2.466 4.09-2.4.01.004Zm-5.1-2.93-4.29-2.465-4.1 2.392 4.29 2.466 4.1-2.393Zm-52.79-13.947 4.29 2.46 4.1-2.392-4.29-2.462-4.1 2.395v-.001Zm19.3 11.083 4.29 2.46 4.1-2.395-4.28-2.459-4.1 2.393-.01.001Zm-14.47-8.312 4.29 2.461 4.1-2.395-4.29-2.459-4.1 2.392v.001Zm19.3 11.082 4.29 2.465 4.09-2.4-4.28-2.462-4.1 2.393v.004Zm18.45-5.77-4.29-2.463-4.1 2.393 4.3 2.461 4.09-2.391Zm-13.62 8.538 4.29 2.466 4.09-2.395-4.28-2.462-4.1 2.391Zm-6.81-20.275-4.3-2.466-4.09 2.395 4.29 2.461 4.1-2.39Zm-12.5 9.183 4.28 2.465 4.1-2.393-4.28-2.465-4.1 2.393Zm4.82 2.771 4.29 2.463 4.1-2.393-4.29-2.463-4.1 2.393Zm1.88-9.478-4.29-2.461-4.1 2.392 4.29 2.462 4.1-2.393Zm31.32 12.185-4.29-2.463-4.1 2.395 4.29 2.461 4.1-2.392v-.001Zm-17.45 7.408-4.29-2.462-4.09 2.393 4.28 2.463 4.1-2.392v-.002Zm-8.4-16.445-4.1 2.393 4.28 2.462 4.1-2.393-4.28-2.462Zm-1.35 10.84-4.29-2.461-4.1 2.393 4.29 2.461 4.1-2.393Zm14.58 8.374-4.29-2.463-4.1 2.393 4.29 2.462 4.1-2.392Zm-7.8-21.908-4.29-2.462-4.09 2.393 4.28 2.461 4.1-2.392Zm-21.54-12.372-4.1 2.393 4.29 2.461 4.09-2.391-4.28-2.463Zm31.75 18.24-4.28-2.463-4.1 2.393 4.29 2.461 4.09-2.391Zm-26.59 2.156-4.29-2.461-4.1 2.391 4.29 2.462 4.1-2.392Z"
            fill="#4361EE"
        />
        <path
            d="m1017.14 90.074-4.09 2.39-4.29-2.46 4.1-2.394 4.28 2.464ZM1023.5 99.529l-4.1 2.393-4.29-2.461 4.1-2.393 4.29 2.46ZM1044.61 105.85l-4.1 2.392-4.29-2.462 4.1-2.393 4.29 2.463ZM1038.14 107.939l-4.1 2.4-4.29-2.466 4.1-2.39 4.29 2.456ZM1043.02 110.743l-4.1 2.393-4.29-2.462 4.1-2.393 4.29 2.462ZM1028.55 119.888l-4.1 2.393-18.84-10.82 4.09-2.393 18.85 10.82ZM1044.94 129.311l-4.09 2.392-8.84-5.079 4.09-2.394 8.84 5.081Z"
            fill="#F8F9FC"
        />
        <path
            d="m1072.78 72.862-53.83-31.08a1.88 1.88 0 0 0-1.89-.183c-.89.515-1.77 1.029-2.66 1.542a1.869 1.869 0 0 1 1.89.183l2.8 1.618a.643.643 0 0 0-.21.082c-.47.272-1.04.6-1.58.918-.36.208-.72.414-1.08.625a1.108 1.108 0 0 0-.46 1.024l-.1 32.792c.03.551.19 1.088.47 1.566.27.478.66.884 1.12 1.185.42-.242.84-.486 1.26-.73l-1.26.73 51.69 29.844c.16.118.35.19.55.209.2.018.41-.017.59-.102l2.6-1.513-.01 3.235c.03.327-.03.657-.16.955a1.87 1.87 0 0 1-.62.745c.44-.256.88-.514 1.32-.769.45-.255.89-.514 1.33-.773.27-.189.48-.446.62-.745.14-.298.19-.628.16-.955l.1-35.815a5.85 5.85 0 0 0-2.64-4.588Z"
            fill="#331083"
        />
        <path
            d="m1069.04 76.517-51.69-29.844c-.88-.507-1.6-.09-1.6.916l-.09 32.792c.03.552.19 1.088.46 1.566.28.478.66.884 1.13 1.185l51.69 29.844c.87.506 1.6.1 1.6-.909l.09-32.795a3.473 3.473 0 0 0-.47-1.566 3.486 3.486 0 0 0-1.12-1.189Z"
            fill="#E8ECEF"
        />
        <path
            d="m1070.12 74.406-53.83-31.08c-1.46-.847-2.66-.162-2.67 1.517l-.1 35.814c.05.921.32 1.818.78 2.617.46.799 1.1 1.478 1.87 1.983l53.84 31.078c1.46.843 2.66.155 2.66-1.526l.1-35.813a5.735 5.735 0 0 0-.77-2.612 5.785 5.785 0 0 0-1.88-1.978Zm.42 37.662c.02.313-.08.621-.27.865a1.023 1.023 0 0 1-1.33.044L1032.61 92l-15.36-8.865c-.02-.01-.04-.026-.06-.037-.06-.037-.11-.076-.17-.119a4.364 4.364 0 0 1-.24-.2 4.232 4.232 0 0 1-.42-.472 4.569 4.569 0 0 1-.23-.362 3.205 3.205 0 0 1-.47-1.562l.1-32.792c0-.064 0-.125.01-.183 0-.056.01-.112.02-.168.02-.099.05-.196.09-.288.05-.092.11-.177.18-.25.02-.024.04-.047.07-.068.02-.02.03-.024.04-.036a.824.824 0 0 1 .36-.133c.09-.01.19-.008.28.006.08.013.15.031.23.056l.07.03c.09.033.17.073.25.118l51.69 29.844c.46.303.84.71 1.12 1.188.28.479.44 1.015.47 1.567l-.1 32.794Z"
            fill="#3F37C9"
        />
        <path
            d="M1038.71 78.633a1.42 1.42 0 0 0-1.41-.143c-.78.443-.78 1.888-.01 3.226.33.605.82 1.114 1.4 1.478a1.42 1.42 0 0 0 1.41.143c.77-.443.78-1.888.01-3.226a4.143 4.143 0 0 0-1.4-1.478Z"
            fill="#F72585"
        />
        <path
            d="M1034.07 76.36a.946.946 0 0 0-.95-.1c-.53.3-.54 1.285-.01 2.195.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005ZM1029.57 73.872a.61.61 0 0 0-.6-.061c-.33.19-.34.809 0 1.381.14.259.35.477.6.633a.61.61 0 0 0 .6.061c.33-.19.33-.808 0-1.381a1.713 1.713 0 0 0-.6-.633ZM1052.57 87.872a.61.61 0 0 0-.6-.061c-.33.19-.34.809 0 1.381.14.259.35.477.6.633a.61.61 0 0 0 .6.061c.33-.19.33-.808 0-1.381a1.713 1.713 0 0 0-.6-.633ZM1049.07 85.098a.946.946 0 0 0-.95-.1c-.53.3-.54 1.284-.01 2.194.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005ZM1038.71 72.633a1.42 1.42 0 0 0-1.41-.143c-.78.443-.78 1.888-.01 3.226.33.605.82 1.114 1.4 1.478a1.42 1.42 0 0 0 1.41.143c.77-.443.78-1.888.01-3.226a4.143 4.143 0 0 0-1.4-1.478ZM1034.07 70.098a.946.946 0 0 0-.95-.1c-.53.3-.54 1.284-.01 2.194.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005ZM1029.57 67.608a.61.61 0 0 0-.6-.061c-.33.19-.34.809 0 1.38.14.26.35.478.6.634a.61.61 0 0 0 .6.061c.33-.19.33-.808 0-1.381a1.714 1.714 0 0 0-.6-.633ZM1052.57 81.608a.61.61 0 0 0-.6-.061c-.33.19-.34.809 0 1.38.14.26.35.478.6.634a.61.61 0 0 0 .6.061c.33-.19.33-.808 0-1.381a1.714 1.714 0 0 0-.6-.633ZM1044.07 65.766a.61.61 0 0 0-.6-.061c-.33.19-.34.809 0 1.381.14.259.35.477.6.633a.612.612 0 0 0 .6.061c.33-.19.33-.808 0-1.381a1.714 1.714 0 0 0-.6-.633ZM1044.07 93.766a.61.61 0 0 0-.6-.061c-.33.19-.34.809 0 1.381.14.259.35.477.6.633a.612.612 0 0 0 .6.061c.33-.19.33-.808 0-1.381a1.714 1.714 0 0 0-.6-.633ZM1039.07 62.766a.61.61 0 0 0-.6-.061c-.33.19-.34.809 0 1.381.14.259.35.477.6.633a.612.612 0 0 0 .6.061c.33-.19.33-.808 0-1.381a1.714 1.714 0 0 0-.6-.633ZM1039.07 90.766a.61.61 0 0 0-.6-.061c-.33.19-.34.809 0 1.381.14.259.35.477.6.633a.612.612 0 0 0 .6.061c.33-.19.33-.808 0-1.381a1.714 1.714 0 0 0-.6-.633ZM1034.07 64.098a.946.946 0 0 0-.95-.1c-.53.3-.54 1.284-.01 2.194.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005ZM1049.07 79.098a.946.946 0 0 0-.95-.1c-.53.3-.54 1.284-.01 2.194.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005ZM1039.07 67.098a.946.946 0 0 0-.95-.1c-.53.3-.54 1.284-.01 2.194.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005ZM1049.07 73.098a.946.946 0 0 0-.95-.1c-.53.3-.54 1.284-.01 2.194.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005ZM1039.07 85.545a.947.947 0 0 0-.95-.1c-.53.3-.54 1.284-.01 2.194.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005ZM1034.07 83.098a.946.946 0 0 0-.95-.1c-.53.3-.54 1.284-.01 2.194.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005ZM1049.07 91.098a.946.946 0 0 0-.95-.1c-.53.3-.54 1.284-.01 2.194.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005ZM1043.71 81.633a1.42 1.42 0 0 0-1.41-.143c-.78.443-.78 1.888-.01 3.226.33.605.82 1.114 1.4 1.478a1.42 1.42 0 0 0 1.41.143c.77-.443.78-1.888.01-3.226a4.143 4.143 0 0 0-1.4-1.478Z"
            fill="#7209B7"
        />
        <path
            d="M1043.71 75.633a1.42 1.42 0 0 0-1.41-.143c-.78.443-.78 1.888-.01 3.226.33.605.82 1.114 1.4 1.478a1.42 1.42 0 0 0 1.41.143c.77-.443.78-1.888.01-3.226a4.143 4.143 0 0 0-1.4-1.478Z"
            fill="#F72585"
        />
        <path
            d="M1044.07 70.098a.946.946 0 0 0-.95-.1c-.53.3-.54 1.284-.01 2.194.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005ZM1044.07 88.545a.947.947 0 0 0-.95-.1c-.53.3-.54 1.284-.01 2.194.23.411.55.757.95 1.005a.98.98 0 0 0 .96.1c.53-.3.53-1.284 0-2.194a2.671 2.671 0 0 0-.95-1.005Z"
            fill="#7209B7"
        />
        <path
            d="m1076.02 108.407 1.91-1.113-2.24-3.883-1.91 1.113 2.24 3.883Z"
            fill="#D7E7F7"
        />
        <path
            d="M1073.78 104.527a4.717 4.717 0 0 1-2.39 1.362l2.24 3.883 2.39-1.362-2.24-3.883Z"
            fill="#F8F9FC"
        />
        <path
            d="m1077.16 107.759-1.14.651-2.39 1.362-1.15.651 8.22 14.219 4.67-2.668-8.21-14.215Z"
            fill="#F72585"
        />
        <path
            d="m1085.36 121.971 1.92-1.113-8.21-14.216-1.91 1.113 8.2 14.216ZM1072.73 105.366l1.91-1.113a4.72 4.72 0 0 0 1.06-.838c2.6-2.77 2.25-8.894-1.05-14.615a24.174 24.174 0 0 0-2.09-3.037l-1.92 1.112c.78.954 1.47 1.97 2.09 3.037 3.3 5.721 3.65 11.844 1.05 14.615-.31.329-.67.612-1.06.838l.01.001Z"
            fill="#B5179E"
        />
        <path
            d="m1070.64 86.876 1.91-1.113a17.413 17.413 0 0 0-4.63-4.059 9.9 9.9 0 0 0-2.91-1.158l-1.91 1.113c1.02.231 2 .622 2.9 1.158a17.302 17.302 0 0 1 4.64 4.06Z"
            fill="#B5179E"
        />
        <path
            d="m1063.1 81.66 1.91-1.114a5.386 5.386 0 0 0-3.84.48l-1.91 1.113a5.37 5.37 0 0 1 3.84-.48Z"
            fill="#B5179E"
        />
        <path
            d="M1066 82.817a19.327 19.327 0 0 1 6.73 7.1c3.3 5.721 3.65 11.844 1.04 14.615a4.637 4.637 0 0 1-2.39 1.362 7.745 7.745 0 0 1-5.44-1.18 19.301 19.301 0 0 1-6.72-7.1c-3.71-6.419-3.69-13.349.04-15.474 1.87-1.068 4.31-.73 6.74.677Zm-5.18 13.88a14.778 14.778 0 0 0 5.13 5.4c1.86 1.073 3.72 1.331 5.14.522 2.84-1.62 2.85-6.9.03-11.794a14.764 14.764 0 0 0-5.12-5.4c-1.86-1.073-3.72-1.332-5.14-.522-2.85 1.62-2.86 6.9-.04 11.794Z"
            fill="#F72585"
        />
        <path
            d="M1066 85.425c-1.86-1.073-3.72-1.332-5.14-.522-2.84 1.62-2.86 6.9-.03 11.794a14.67 14.67 0 0 0 5.12 5.4c1.86 1.073 3.72 1.331 5.14.522 2.84-1.62 2.86-6.9.03-11.794a14.765 14.765 0 0 0-5.12-5.4Z"
            fill="#4CC9F0"
        />
    </svg>
)

export default SvgComponent
